export default {
    "corporate": "Virksomhedsprogram",
    "onboarding": {
        "goal_desc": "Du optjener %{customPoints} for at spore din aktivitet og bonus %{customPoints} for at nå dine mål. Det er tid til at komme i gang! Du kan have 3 personlige mål aktive på et hvilket som helst tidspunkt.",
        "sample_task": {
            "modalActivityTitle": "3 dybe indåndinger",
            "rewards_featured_title": "Udvalgte",
            "rewards_partners_title": "Partnere",
            "header_description": "Du optjener %{customPoints} ved at spore din aktivitet og fuldføre opgaver, mål og udfordringer.",
            "icon_text": "Tryk på {icon} for at spore en dyb indånding.",
            "activityName": "dyb vejrtrækning",
            "activityUnit": "vejrtrækning"
        },
        "lets_get_started": "Lad os komme i gang!",
        "start_description": "Du optjener %{customPoints} ved at spore din aktivitet og fuldføre opgaver, mål og udfordringer.",
        "complete_and_earn": "Gennemfør og optjen",
        "did_it": "Jeg gjorde det!",
        "task_complete": "Opgave fuldført!",
        "breath_sample_task": "Tag en hurtig vejledning om aktivitetssporing",
        "track_a_sample_activity": "Spor en prøveaktivitet",
        "nice": "Flot!",
        "nice_one": "Godt gået!",
        "nice_subtext_1": "Du har optjent %{points} %{customPoints}.",
        "nice_subtext_2": "Optjening af %{customPoints} hjælper dig med at stige i niveau. Hver gang du stiger et niveau op, optjener du %{reward_currency}, som kan indløses til gode tilbud.",
        "nice_subtext_3": "Du optjener flere point, når du udfører flere opgaver, registrerer aktivitet og gennemfører mål og udfordringer.",
        "progress_subtitle": "Dine %{customPoints} og fremskridt nulstilles hver %{frequency}.",
        "skip_for_now": "Spring over for nu",
        "loadingText": "Hold ud, mens vi beregner din trivselsscore.",
        "goal_title": "Indstil et personligt mål",
        "swipe_for_more": "Swipe for at se mere",
        "skip_goals": "Jeg er færdig med at sætte mål for nu.",
        "complete_profile": "",
        "level": "Niveau",
        "finish_onboarding_action": "Gennemfør venligst først onboarding",
        "vital_stats": {
            "height_ft": "Højde ft.",
            "height_in": "Højde i."
        },
        "rewards": "",
        "welcome": {
            "disclaimerTitle": "Dit privatliv er vigtigt"
        },
        "levels": {
            "title": "Præstationer og belønninger",
            "tableTitle": "Resultater"
        },
        "initialScreen": {
            "title": "Velkommen til %{programName} %{username}!",
            "getRewarded": "Bliv belønnet med %{rewardName}",
            "completeAgainst": "Konkurrerer mod dine kolleger",
            "earnPoints": "Optjen point med wellness-aktiviteter",
            "levelUp": "Gå op i niveau og få badges"
        },
        "starterGoals": {
            "title": "Vælg et mål",
            "subtitle": "Få mere velvære med en ny vane"
        }
    },
    "healthkit_not_available": "Det er ikke muligt at oprette forbindelse til Apple Health. I appen Sundhed skal du under Kilder sikre dig, at du som minimum har aktiveret tilladelse til skridt og har mindst 1 skridt sporet.",
    "changeCover": "Ændr foto",
    "joiningCommunityToast": {
        "success": {
            "message": "Du har succesfuldt tilmeldt dig %{name}",
            "title": "Tilmeld dig fællesskabet"
        }
    },
    "achievement_starts_date": "Begynder: %{date}",
    "editChallenge": "Rediger %{challengeName}",
    "createChallenge": {
        "activitiesOrCategory": {
            "subtitle": "Vælg op til 5 aktiviteter",
            "title": "Hvad vil du gerne gøre?",
            "noActivityTitle": "Tilføjelse af aktiviteter",
            "noActivityMessage": "Vælg mindst én aktivitet eller kategori.",
            "categoryItemDescription": "Alle aktiviteter i %{category}-kategorien",
            "addActivityTitle": "Hvor mange %{unit} af %{activity} ønsker du at lave pr. %{period}?",
            "addCategoryQuantityTitle": "Hvor mange %{customPoints} vil du optjene i %{category}-kategorien?",
            "subtitleCategories": "Vælg en kategori. Alle aktiviteter fra denne kategori bidrager til målet.",
            "subtitleWithActivities": "%{num} af %{max} aktiviteter valgt",
            "selectCategoryMessage": "Alle aktiviteter i kategorien vil blive valgt, og de tidligere valgte aktiviteter vil blive udeladt.",
            "addActivityTitleTotal": "Hvor meget %{activity} ønsker du at lave i %{period}?"
        },
        "inviteDepartments": {
            "title": "Inviter afdelinger\/afdeling"
        },
        "inviteRegions": {
            "title": "Inviter regioner"
        },
        "createInvitation": {
            "selectMore": "Vælg mindst 2 %{entity}s!"
        },
        "visibility": {
            "title": "Synlighed",
            "description": "Teamudfordringer kan findes og tilmeldes af alle %{programName} brugere."
        },
        "highest": {
            "name": "Flest %{customPoints} vinder",
            "description": "Ingen grænser, højeste %{customPoints} giver 1. pladsen"
        },
        "compete": {
            "individual": "Deltag som enkeltperson",
            "team": "Konkurrer som et hold"
        },
        "unitType": {
            "title": "Vælg, hvordan du fuldfører dit mål",
            "subtitle": "Vælg mellem aktiviteter eller en kategori"
        },
        "category": {
            "name": "Alle aktiviteter i en kategori",
            "description": "F.eks. Spor alle aktiviteter i \"Bevæg dig",
            "title": "Vælg en kategori",
            "subtitle": "Fra hvilken kategori vil du spore aktiviteter?"
        },
        "activities": {
            "name": "Udvalgte aktiviteter",
            "description": "F.eks. spore specifikke aktiviteter som cykling",
            "title": "Vælg aktiviteter",
            "subtitle": "Vi anbefaler, at du fokuserer på en enkelt aktivitet, men du kan tilføje op til 5",
            "maxModalTitle": "Maksimalt antal valgte aktiviteter",
            "maxModalDescription": "Du kan højst tilføje 5 aktiviteter. Tryk på Accepter for at fortsætte med dine 5 valgte aktiviteter eller på Rediger for at foretage ændringer.",
            "warningModalTitle": "Høj sværhedsgrad",
            "warningModalDescription": "Du har angivet mange aktiviteter, der skal gennemføres pr. periode i dette mål. Er du sikker på, at du ønsker at angive et så udfordrende mål?",
            "requiredPoints": "kræves for at opfylde %{period} %{challengeType}",
            "noActivitiesModalTitle": "Tilføjelse af aktiviteter",
            "noActivitiesModalDescription": "Vælg mindst én aktivitet."
        },
        "categoryQuantity": {
            "title": "Indstil dit %{customPoints}-mål",
            "subtitle": "Hvor mange %{customPoints} ønsker du at tjene fra %{category} hver %{period}?",
            "subtitleTotal": "Hvor mange %{customPoints} ønsker du at tjene fra %{category} %{period}?",
            "text": "Som en retningslinje er 30 minutters moderat aktivitet lig med ca. 105 %{customPoints}",
            "noQuantityModalTitle": "Antal",
            "noQuantityModalDescription": "Indtast en værdi",
            "defaultCategoryTitle": "nuværende kategori"
        },
        "cancel": {
            "title": "Annuller oprettelse af udfordring",
            "message": "Er du sikker på, at du ønsker at annullere oprettelsen af en udfordring?"
        },
        "createNew": "Opret ny udfordring",
        "chooseChallengeTitle": "Vælg en udfordring, eller opret din egen",
        "createOwn": {
            "title": "Opret min egen"
        },
        "frequency": {
            "title": "Hvor ofte vil du opfylde dit mål?",
            "subtitle": "Daglige mål er gode vaneopbyggerne"
        },
        "startAndDuration": {
            "title": "Vælg en startdato og varighed",
            "subtitle": "",
            "noFieldsTitle": "Startdato og varighed",
            "noFieldsMessage": "Udfyld venligst startdato og varighed"
        },
        "finalize": {
            "title": "Gennemgå dit nye mål",
            "subtitle": "",
            "noFieldsTitle": "Navn og vejledning",
            "noFieldsMessage": "Udfyld venligst navn og instruktioner",
            "name": "Mit %{frequency} %{names} mål",
            "instructionCategory": "Optjen %{points} %{customPoints} %{frequency} fra alle %{category} aktiviteter",
            "instructionActivities": "Spor %{items} %{frequency} og optjen %{points} %{customPoints} %{pointsFrequency}",
            "instructionCompetitionCategory": "Få flest %{customPoints} fra alle %{category} aktiviteter for at vinde denne konkurrence",
            "instructionCompetitionActivities": "Få flest %{customPoints} fra %{items} for at vinde denne konkurrence",
            "namePlaceholder": "Navngiv din konkurrence",
            "titleChallenge": "Afslut din udfordring"
        },
        "dailyDescription": "F.eks.: Drik 8 glas vand hver dag",
        "weeklyDescription": "F.eks. gå 150 minutter hver uge",
        "monthlyDescription": "F.eks. løbe 150 km hver måned",
        "totalDescription": "F.eks. cykle i alt 10 000 km",
        "title": "Udfordre dig selv eller andre?",
        "navigatorTitle": "Opret en udfordring",
        "me": {
            "name": "Bare mig selv",
            "description": "Udfordre dig selv med et personligt mål"
        },
        "others": {
            "name": "Konkurrer med andre",
            "description": "Konkurrere individuelt eller som et hold"
        },
        "one": {
            "name": "Individuelt",
            "description": "Gennemfør individuelt sammen med andre brugere"
        },
        "team": {
            "name": "Som et hold",
            "description": "Gennemfør som et hold med andre hold"
        },
        "company": {
            "name": "Virksomhedens udfordring",
            "description": "Skab en særlig konkurrence"
        },
        "adminItemTitle": "Som administrator kan du oprette",
        "userOrTeamTitle": "Konkurrere individuelt eller som et hold?",
        "target": {
            "name": "Sæt et mål, der skal nås",
            "description": "Udfordring, der har en øvre grænse"
        },
        "typeTitle": "Vælg en %{challengeType} type",
        "teamSizeTitle": "Vælg en størrelse for hvert hold",
        "teamSizeSubtitle": "Den mindste størrelse af et hold er %{min} og den maksimale er %{max}. Dit holds %{customPoints} er gennemsnittet af alle medlemmer på holdet, og du kan kun optjene %{customPoints}, når dit hold har nået det mindste antal medlemmer.",
        "teamSize": {
            "noFieldsTitle": "Min og max",
            "noFieldsMessage": "Vælg det mindste og største antal medlemmer til et hold"
        },
        "companyChallengeTitle": "Virksomhedens udfordring",
        "companyChallengeSubtitle": "Du er en administrator. Du kan oprette afdelingsudfordringer og andre typer udfordringer",
        "chooseDepartmentTitle": "Vælg afdelinger\/afdelinger at konkurrere i",
        "chooseRegionTitle": "Vælg regioner at konkurrere i",
        "goToChallenge": "Gå til min udfordring",
        "additional": {
            "title": "Udfordring oprettet",
            "subtitle": "Lad os komme i gang! Inviter andre til at deltage.",
            "makePublicName": "Gør dette offentligt",
            "makePublicDescription": "Alle kan deltage",
            "toDirectoryName": "Indsend til udfordringskataloget",
            "toDirectoryDescription": "Folk kan oprette en lige som denne",
            "inviteTitle": "Inviter til udfordring",
            "titleGoal": "Mål oprettet!"
        },
        "quantityMinimum": {
            "message": "Den mindste krævede mængde er %{quantity}",
            "title": "Utilstrækkelig mængde"
        },
        "toast": {
            "success": "Din %{challengeType} er blevet oprettet."
        },
        "goToGoal": "Gå til mit mål",
        "navigatorTitleGoal": "Opret et mål",
        "quantityError": {
            "wholeNumber": "Skal være et helt tal",
            "greaterThanZero": "Skal være større end 0"
        }
    },
    "wellbeing": {
        "description": {
            "overall": "Din trivselsscore beregnes ved at sammenligne de svar, du har givet i trivselsundersøgelsen, med svarene fra millioner af andre personer i samme alders- og kønskategori som dig. Din score viser, hvor du ligger i forhold til dem. Din score opdateres automatisk hver måned i henhold til ændringer i din adfærd med hensyn til bevægelse, mad og følelse, som du indtaster i appen. Hvis du konsekvent sætter dig mål og tager positive tiltag for at forbedre dit helbred, kan det være med til at øge din trivselsscore.",
            "excellent": "Din sundhedsscore er bedre end 85 % af personer på din alder og af dit køn. ",
            "very_good": "Din sundhedsscore er bedre end 70-84 % af personer på din alder og af dit køn.",
            "good": "Din sundhedsscore er bedre end 51-69 % af personer på din alder og af dit køn.",
            "fair": "Din sundhedsscore er bedre end 31-50 % af personer på din alder og dit køn.",
            "poor": "Din sundhedsscore er lavere end 70 % af personer på din alder og dit køn. Det er aldrig for sent at begynde at prioritere dit helbred. Udnyt vores platform til at hjælpe dig med at gøre fremskridt i din wellness-rejse!",
            "overall_result": "Samlet set er din trivselsscore %{status}.",
            "category_result": "Samlet set er din {category} score {string}.",
            "goals": "Du kan ikke vinde uden mål. Sæt op til 3 personlige mål, og følg udviklingen hen imod dem. Efterhånden som du foretager livsstilsændringer, vil du se din score stige."
        },
        "reminder": {
            "title": "Det er på tide at opdatere din trivselsundersøgelse!",
            "updateAnswers": "Opdater mine svar"
        },
        "lastUpdated": "Sidst opdateret %{date}",
        "scoreDescription": {
            "part1": "Din score er",
            "part2": "score på",
            "belowAverage": "under gennemsnittet",
            "aboveAverage": "over gennemsnittet",
            "part3": "til andre på din alder og dit køn."
        },
        "improveScore": {
            "description": "Din score beregnes på baggrund af dine svar i trivselsundersøgelsen og din sporede aktivitet. Du kan opdatere dine undersøgelsessvar eller sætte nye mål for at forbedre dig.",
            "desc1": "Din score kan ikke blive meget højere! For at holde dine rutiner interessante kan du udfordre dig selv med mål, der ligger lige over din normale kapacitet, og invitere andre til at konkurrere med dig for at holde motivationen ved lige.",
            "desc2": "Hvis du er klar til at stige i niveau, er det tid til at øge udfordringen. Udfordr dig selv med mål, der ligger lige over din normale kapacitet, og inviter andre til at konkurrere med dig for at holde motivationen ved lige.",
            "desc3": "Sæt dig personlige mål, og lav offentlige udfordringer for at holde dig selv ansvarlig og bevare motivationen. Sørg for at vælge opnåelige mål og mindre tidsrammer - vi anbefaler 1 uge.",
            "desc4": "Det er vigtigt at være aktiv hver dag. Hvis du ikke har meget bevægelse i din daglige rutine, skal du starte med små mål, der passer til dine evner og interesser. Sørg for at vælge mål, der kan nås, og mindre tidsrammer - vi anbefaler 1 uge."
        },
        "recommendedGoals": "Anbefalede mål",
        "recommendedDescription": {
            "desc1": "Sæt op til ",
            "desc2": "3 mål ",
            "desc3": "for at fokusere på at forbedre dit velbefindende. Du har i øjeblikket "
        },
        "categoryScore": "Din %{category} score er ",
        "learnMore": "Få mere at vide",
        "youAreSet": "Du er klar!",
        "goalSetting": "Målsætning",
        "attention": "%{category} score ikke tilgængelig.",
        "move": {
            "error": "På baggrund af dine svar er din score for bevægelse ikke tilgængelig. "
        },
        "eat": {
            "error": "Du har angivet, at en sundhedsperson har fortalt dig, at du har type 2-diabetes, og at den ikke er håndteret. "
        },
        "feel": {
            "error": "Baseret på dine svar er din feel score ikke tilgængelig. "
        },
        "survey": {
            "requiredField": "* dette felt er påkrævet"
        },
        "score_info_title": "Hvad min score betyder",
        "company_average_info": "Gennemsnitlig i min virksomhed",
        "demographic_average_info": "Gennemsnitlig i min demografiske gruppe",
        "score": "Velværescore",
        "table": {
            "what_it_means": "Hvad betyder det",
            "score": "Score"
        },
        "updated": "Opdateret",
        "label": {
            "excellent": "Fremragende",
            "very_good": "Meget god",
            "good": "God",
            "fair": "Rimelig",
            "poor": "Dårlig"
        },
        "activity": {
            "eat": "Spis Aktivitet 1, Spis Aktivitet 2, Spis Aktivitet 3",
            "move": "Bevægelse Aktivitet 1, Bevægelse Aktivitet 2, Bevægelse Aktivitet 3",
            "feel": "Føl Aktivitet 1, Føl Aktivitet 2, Føl Aktivitet 3"
        },
        "score_info_screen": "Hvordan er min score beregnet?",
        "details": "Detaljer",
        "activities": "Aktiviteter",
        "improveCategoryScore": "Forbedre min %{category} score",
        "meaning": {
            "heading": "Beregning af score"
        },
        "score_button": {
            "meaning": "Hvad betyder denne score?"
        },
        "improve": "Se anbefalede mål",
        "score_text": {
            "demographic": "Den gennemsnitlige score for din alder og dit køn er",
            "company": "og den gennemsnitlige score i din virksomhed er"
        },
        "scoreHigher": "højere end gennemsnittet af",
        "scoreLower": "lavere end gennemsnittet af",
        "settedGoals": {
            "noGoals": "Ingen mål fastsat",
            "one": "1 mål fastsat",
            "n": "%{count} mål sat"
        },
        "yourScoreIsPoor": "Din %{category} score er dårlig",
        "unlock": {
            "title": "Lås op for din trivselsscore",
            "description": "Udfyld et kort spørgeskema for at få at vide, hvordan dit generelle helbred er sammenlignet med andre personer i din demografiske gruppe."
        },
        "browseAndSet": "Du kan gennemse og opstille nye mål, når dine nuværende mål er nået til vejs ende.",
        "excellent": {
            "desc1": "Ekstraordinær sund livsstil",
            "desc2": "Meget lav sundhedsrisiko"
        },
        "veryGood": {
            "desc1": "Meget sund livsstil",
            "desc2": "Lav sundhedsrisiko"
        },
        "good": {
            "desc1": "Sund livsstil",
            "desc2": "Gennemsnitlig sundhedsrisiko"
        },
        "fair": {
            "desc1": "Lidt sund livsstil",
            "desc2": "Over gennemsnitlig sundhedsrisiko"
        },
        "poor": {
            "desc1": "Høj sundhedsrisiko",
            "desc2": "Mere daglig bevægelse anbefales",
            "desc3": "Der er behov for mere daglig bevægelse"
        },
        "calculateScore": {
            "description": "Når du udfylder trivselsundersøgelsen, analyseres dine svar ved hjælp af milliarder af datavariabler fra personer på din alder og dit køn. Beregningen tager også højde for den aktivitet, du registrerer i %{programName}.\n\nDin trivselsscore opdateres regelmæssigt, så du kan se, hvordan den ændrer sig over tid."
        },
        "improveYourScore": "Forbedring af din score"
    },
    "challengerCount": "%{num} udfordrere",
    "team_name": "Hold navn",
    "syncingDeviceToast": {
        "danger": {
            "message": "Ups... Vi havde et problem med at synkronisere %{name}. Prøv venligst igen.",
            "title": "Synkronisere"
        },
        "success": {
            "title": "Synkronisere",
            "message": "Synkroniseringen af %{name} er lykkedes. Dine aktiviteter er nu opdaterede."
        }
    },
    "allCompanyMembers": "Alle selskabets medlemmer",
    "allCompanyMembersTeam": "Alle firmamedlemmer (team)",
    "successfullyRedeemedItemForConfirmation": "Det er lykkedes dig at indløse denne vare, og en bekræftelsesmail er blevet sendt til %{email}.",
    "no_all_events_placeholder": "Det ser ud til, at der ikke er nogen begivenheder, som man kan deltage i på dette tidspunkt. Hvorfor opretter du ikke en?",
    "confirmDeleteAccount": "Bekræft sletning ved at indtaste den e-mailadresse, der er knyttet til din konto",
    "deleteAccount": "Slet konto",
    "linkAccounts": "Administrer tilknyttede konti",
    "titleSlug": {
        "icon_reward_text": "Det er nemt for berettigede medlemmer at optjene flere point ved at handle hos vores partnere eller på en kontrolundersøgelse hos en Members' Choice Advantage-tandlæge ved hjælp af deres ekstra dækning.",
        "icon_move_text": "Ved at følge hverdagens sunde valg som at sove bedre eller spise grøntsager kan du optjene Live Better-point.",
        "icon_redeem_text": "Live Better belønner Medibank-medlemmer, der har hospitals- eller ekstradækning, for at passe på deres helbred. ",
        "icon_phone_text": "Tilmeld dig, og du er på vej til at indløse belønninger som f.eks. gavekort til sundhed og velvære eller besparelser på din sundhedsdækning. ",
        "wellness": "Velkommen til en verden af velvære",
        "goals": "Opnå dine mål",
        "devices": "Bliv på sporet",
        "challenges": "Skab udfordringer",
        "celebrate": "Social velvære",
        "habits": "Opbyg sunde vaner",
        "joinChallenge": "Deltag i udfordringen",
        "getSocial": "Bliv social",
        "reward": "Bliv belønnet for at leve et sundere liv.",
        "move": "Bevæg dig, spis og få det bedre.",
        "phone": "Lev bedre, føl dig bedre."
    },
    "viewProgress": {
        "goal": "Se målfremskridt",
        "challenge": "Se fremskridt med hensyn til udfordringer",
        "progress": "Se fremskridt"
    },
    "vitalStats": {
        "disclaimer": {
            "message": "Indtastning af disse oplysninger er valgfri, til din egen fordel og er privat for dig."
        }
    },
    "eventBonusPoints": {
        "section": {
            "title": "%{potentialBonusPoints} bonus %{customPoints} er tilgængelige for denne begivenhed!"
        },
        "modal": {
            "paragraph1": "Ved at deltage i denne begivenhed optjener du bonus %{pointsName}.",
            "paragraph2": "Alle bonus %{pointsName} gives efter at begivenheden er afsluttet. Du vil ikke modtage bonuspoint for begivenheder, som du ikke deltager i."
        }
    },
    "EAP": {
        "contactInfo": "Kontaktoplysninger",
        "doLater": "Jeg gør det senere",
        "tellMore": "Fortæl mig mere",
        "contactMe": "Kontakt mig",
        "title": "Program for hjælp til medarbejdere og familier",
        "reachGoal": {
            "title": "Der er hjælp at hente",
            "description": "Dit Employee and Family Assistance Program (EFAP), der leveres af %{providerName}, tilbyder en række sundhedscoaching-tjenester, der kan hjælpe dig med at nå dine mål for dit velvære.\n\nVil du gerne have %{providerName} til at kontakte dig med flere oplysninger?"
        },
        "privacyPolicy": "%{provider} Politik om beskyttelse af personlige oplysninger"
    },
    "HRIS": {
        "disclaimer": "Disse oplysninger indstilles automatisk og kan ikke ændres"
    },
    "settingGoals": {
        "description": "Hvis du fokuserer på 3 anbefalede mål ad gangen, vil du øge sandsynligheden for succes.",
        "title": {
            "one": "Du har sat 1 mål"
        }
    },
    "auth": {
        "linkAccount": {
            "alreadyLinkedToUser": "Kontoen er allerede knyttet til en anden bruger",
            "lastAccountMessage": "Er du sikker på, at du ønsker at fjerne din sidst tilknyttede konto? Når du er fjernet, skal du logge ind med e-mail-adressen %{email} og en ny adgangskode.",
            "unlinkCorpAccountMessage": "Er du sikker på, at du ønsker at fjerne din virksomheds tilknyttede konto? Når den er fjernet, skal du logge ind med e-mail-adressen %{email} igen.",
            "alreadyLinked": "Konto allerede knyttet",
            "unlinkMessage": "Er du sikker på, at du ønsker at fjerne en tilknyttet konto?"
        },
        "sso": {
            "emailNotVerified": "Din e-mail er ikke verificeret."
        },
        "signIn": {
            "dontHaveAccount": "Har du ikke en konto?",
            "enterPIN": "Indtast din virksomheds programidentifikationsnummer",
            "dontKnowPIN": "Kender du ikke din pinkode?",
            "pin": "PIN-KODE",
            "register": "Tilmeld",
            "pinDescription": "Kontakt din programadministrator, hvis du er i tvivl om din organisations unikke Program Identification Number (PIN). Hvis du har en pinkode og har problemer med at gå videre til næste trin, skal du kontakte support@sproutatwork.com.",
            "keepMeTooltip": "For nemheds skyld vil din session forblive gyldig i 30 dage, når dette felt er markeret. På delte enheder anbefaler vi, at du fjerner markeringen i dette felt og logger ud, når du er færdig."
        },
        "signUp": {
            "backToLogin": "Tilbage til login",
            "termsOfService": "Vilkår for service",
            "privacyPolicy": "Politik om beskyttelse af personlige oplysninger"
        },
        "createYourAccount": "Opret din konto",
        "setYourDetails": "Indtast dine oplysninger",
        "ModaHybridLogin": {
            "noAccessDashboard": "Har du ikke adgang til medlemskontrolpanelet?",
            "signUpSSOButton": "Tilmeld dig via Moda Member Dashboard",
            "noAccessDashboardWeb": "Hvis du ikke har adgang til medlemsdashboardet, skal du logge ind med din e-mail og adgangskode nedenfor.",
            "loginSSOButton": "Log ind via Moda Member Dashboard"
        }
    },
    "entityHasBeenDeleted": "%{name} er blevet slettet",
    "track_challenge": {
        "message": {
            "manually": "Spor manuelt",
            "automatically": "Spores automatisk med %{appOrDeviceName}",
            "manuallyOrConnect": "Spor manuelt eller tilslut en app eller enhed",
            "manuallyAndBy": "Spor manuelt og automatisk med %{appOrDeviceName}",
            "reconnectDevice": "Enhed påkrævet. Tilslut venligst din enhed igen",
            "manualAndAuto": "Sporing manuelt og automatisk",
            "trackedAutomatically": "Spores automatisk"
        }
    },
    "signUpPartnerSSOToast": {
        "danger": {
            "title": "Kan ikke tilmelde dig",
            "message": "Kan ikke hente brugeroplysninger fra partner. Prøv venligst igen senere"
        }
    },
    "app_device_required": {
        "disclaimer": {
            "title": "Der kræves en app eller enhed til dette %{goalName}.",
            "subTitle": "Tilslut venligst en app eller enhed"
        }
    },
    "descriptionSlug": {
        "wellness": "Bliv medlem af det sundhedsfællesskab, der hjælper dig med at sætte mål, oprette forbindelse og holde dig på sporet.",
        "goals": "Fortæl os, hvad du arbejder hen imod. Vi hjælper dig med at nå dertil med anbefalede mål.",
        "devices": "Synkroniser din fitnessenhed, eller log dine aktiviteter, og hold dine mål for dit velvære på sporet.",
        "challenges": "Start lidt venskabelig konkurrence.  Opret en udfordring, og inviter andre til at deltage i det sjove.",
        "celebrate": "Hold kontakten med kolleger, og fejr dine succeser sammen.",
        "habits": "Registrer wellness-aktiviteter for at optjene point. Link til din telefon eller wearable for at tjene hurtigere.",
        "joinChallenge": "Se, hvordan du klarer dig i forhold til dine kolleger i venskabelige konkurrencer.",
        "getSocial": "Hold kontakten med kolleger, og fejr dine succeser sammen.",
        "reward_text": "Optjen point for at gennemføre daglige aktiviteter og personlige udfordringer.",
        "move_text": "Uanset om det er en gåtur rundt om blokken, fem minutters mindfulness eller en stribe sunde spisevaner, bliver du belønnet.",
        "phone_text": "Brug dine point til rabatter på din dækning og gode tilbud, valget er dit.",
        "none": ""
    },
    "core": {
        "featureNotEnabled": "Funktionen er ikke aktiveret",
        "checkAppVersion": {
            "message": "Det ser ud til, at din app er forældet. Installer venligst den seneste opdatering.",
            "button": "Opdater %{appName}"
        },
        "noConnection": {
            "title": "Ingen netværksforbindelse",
            "description": "Det ser ud til, at du ikke har forbindelse til internettet. Du vil ikke kunne bruge programmet fuldt ud, medmindre du har en forbindelse.",
            "button": "Genoptag"
        },
        "uploadPhotoText": "Tilføj et foto til din %{entityType}",
        "entities": {
            "community": "fællesskab",
            "event": "begivenhed",
            "team": "team",
            "goal": "mål",
            "challenge": "udfordring",
            "competition": "konkurrence"
        }
    },
    "registration": {
        "login": {
            "errorHeading": "Kan ikke logge ind",
            "resetPasswordHeading": "Nulstilling af adgangskode påkrævet"
        },
        "signup": {
            "corporateOrOther": "Er du ikke medlem af Medibank? Eller en del af et virksomhedsprogram?",
            "sign_up_here": "Tilmeld dig her ",
            "errorHeading": "Kan ikke tilmelde dig",
            "areYouMedibankMember": "Er du medlem af Medibank?",
            "isMedibankMember": "Jeg er medlem",
            "isNotMedibankMember": "Jeg er ikke medlem"
        },
        "bpidExists": "Den angivne e-mail er allerede tilknyttet en live better-bruger, e-mailen skal være unik.",
        "generalError": "Tjenesten er i øjeblikket ikke tilgængelig"
    },
    "rewardsNoAvailableProducts": "Der er ingen tilgængelige produkter på dette tidspunkt.",
    "endedGoal": {
        "timeToTrack": {
            "yes": "Du har stadig tid til at spore!",
            "no": "Din %{type} er afsluttet"
        },
        "grace": "Din %{type} er måske ophørt, men du har %{n} %{text} til at spore eventuelle glemte aktiviteter",
        "notGrace": {
            "goal": "Tillykke med at have fuldført dit mål! Fortsæt det gode arbejde ved at sætte et nyt mål for at holde dig på sporet med dit velvære.",
            "competition": "Tillykke med at have fuldført udfordringen! Bevar dit momentum ved at deltage i en anden udfordring eller ved at oprette din egen."
        }
    },
    "appDeviceModal": {
        "defaultMessage": "Tilslut din enhed eller app, og få glæde af problemfri sporing. Din autentificering giver vores teknologipartner \"Sprout\" mulighed for sikkert at overføre dine data fra din %{appDeviceTitle}-konto."
    },
    "noTransactionsMessage": "Det ser ud til, at du ikke har foretaget nogen transaktioner.",
    "noRedemptionsMessage": "Det ser ud til, at du endnu ikke har foretaget nogen indløsninger.",
    "challengeCarousel": {
        "emptyChallenge": {
            "subtitle": "Du kan deltage i udfordringer som enkeltperson eller som et hold",
            "prompt": "Der er ingen udfordringer at deltage i lige nu. Hvorfor ikke oprette en?"
        },
        "createChallengeButton": "Opret en udfordring"
    },
    "eventCarousel": {
        "emptyEvents": {
            "subtitle": "Begivenheder kan være forbeholdt inviterede eller åbne for alle.",
            "button": "Opret en begivenhed"
        },
        "emptyEventsMessage": "Der er ingen begivenheder, du kan deltage i lige nu. Hvorfor ikke oprette en?"
    },
    "appnameLiveBetter": "Lev bedre",
    "appnameTelus": "Velvære",
    "appnameUPnGo": "UPnGO",
    "personal_goal": {
        "carousel": {
            "headingNoSet": "Du har ikke sat nogen mål!",
            "descriptionNoSet": "Forbedr din trivselsscore ved at sætte nogle mål. Kom hurtigt i gang med et anbefalet mål, vælg fra kataloget, eller opret dit eget mål.",
            "descriptionSet": "Du kan sætte et af de anbefalede mål, som vi har lige til dig, gennemse hele kataloget eller oprette dit eget mål.",
            "action_text": "Sæt et nyt mål",
            "heading_singular": "Du kan sætte 1 mål mere",
            "heading_plural": "Du kan indstille %{number} flere mål"
        },
        "heading": "Personlige mål",
        "single": "Personligt mål"
    },
    "settingGoal": {
        "yourGoal": "Dine %{units}",
        "yourGoalDescription": "Du er på vej! De følgende %{units} vil blive indstillet og vil starte med det samme.",
        "selectedGoals": "Udvalgte mål",
        "recommendedDescription": {
            "maximumSet": "Du har indstillet det maksimale antal mål. Du kan gennemse og sætte nye mål, når dine nuværende mål er afsluttet.",
            "maximumSetTitle": "Du har %{count} mål sat"
        }
    },
    "activityLogRemoved": {
        "single": {
            "success": "Aktiviteten er blevet fjernet",
            "info": "Noget gik galt. Prøv venligst igen.",
            "danger": "Noget gik galt... Prøv venligst igen."
        },
        "plural": {
            "success": "Aktiviteterne er blevet fjernet",
            "info": "Noget gik galt... Prøv venligst igen.",
            "danger": "Noget gik galt... Prøv venligst igen."
        },
        "success": "Aktiviteten er blevet fjernet",
        "info": "Aktiviteten er ikke blevet fjernet. Prøv venligst igen.",
        "danger": "Aktiviteten er ikke blevet fjernet. Prøv venligst igen."
    },
    "participants": "Deltagere",
    "members": "Medlem(mer)",
    "timeSittingInformationOld": "Retningslinjerne anbefaler at:\n- Minimere den tid, der bruges på langvarigt siddende arbejde\n- Afbryde lange perioder med siddende arbejde så ofte som muligt.",
    "timeSittingInformation": {
        "title": "Retningslinjerne anbefaler at:",
        "list": "- Minimer den tid, der bruges på langvarigt siddende arbejde.\n- Afbryd lange perioder med siddende arbejde så ofte som muligt."
    },
    "activityLevelInformationOld": "Retningslinjerne anbefaler:\n- At være aktiv de fleste, helst alle dage hver uge\n- At samle over 150 minutters fysisk aktivitet af moderat intensitet hver uge\n- At dyrke muskelstyrkende aktiviteter mindst 2 dage hver uge.",
    "activityLevelInformation": {
        "title": "Retningslinjerne anbefaler:",
        "list": "- At være aktiv de fleste, helst alle dage hver uge.\n- At samle over 150 minutters fysisk aktivitet af moderat intensitet hver uge.\n- At dyrke muskelstyrkende aktiviteter mindst 2 dage hver uge."
    },
    "viewGuidelines": "Se retningslinjerne",
    "corporateAccountLink": {
        "verification": {
            "title": "Bekræft din arbejds-e-mailadresse",
            "description": "Du skal bekræfte din arbejds-e-mailadresse for at gennemføre linkingprocessen med succes. Følg venligst de instruktioner, der er sendt til:"
        }
    },
    "invitation": {
        "findFriendsAndFamily": "Find venner og familie",
        "findFriends&Family": "Find venner og familie",
        "tapToAddFriendsAndFamily": "Tryk på for at tilføje til venner og familie",
        "addedFriendsAndFamily": "Tilføjet til venner og familie",
        "whoYouAreLookingFor": "Kan du ikke se, hvem du leder efter?",
        "inviteWithEmail": "Inviter med e-mail",
        "sentInvitations": "Sendte invitationer",
        "foundPerson": "Vi har fundet denne person med en matchende e-mail",
        "youAreBoth": "I er begge i %{entityName}",
        "youAreBothMore": "I er begge i %{entityName}, +%{n} mere",
        "noFriendsAndFamilyAdded": "Det ser ud til, at du ikke har tilføjet nogen venner eller familie endnu.",
        "sendInvitation": "Send invitation",
        "youHaveNoSentInvitations": "Du har ikke sendt nogen invitationer",
        "toast": {
            "success_title": "Invitation sendt",
            "success_description": "%{invite_email} vil se invitationen i deres indbakke",
            "danger_title": "Invitationen var ikke vellykket",
            "danger_description": "Prøv venligst igen senere"
        },
        "email": {
            "invalid_email": "Indtast venligst en gyldig e-mailadresse"
        },
        "inviteOthers": "Inviter andre",
        "searchForSomeone": "Søg efter nogen",
        "searchForOthersToInvite": "Søg efter andre at invitere",
        "programNameOnly": {
            "title": "Kun %{programName}",
            "description": "Denne %{entityType} er kun tilgængelig for personer, der er en del af %{programName}"
        },
        "domainCannotBeUsed": "Dette domæne kan ikke bruges sammen med %{programName}",
        "actionSearchByEmail": "Inviter via e-mail, hvis du ikke kan finde den person, du leder efter",
        "send": "Send",
        "addEmailToList": "Tilføj e-mail til listen",
        "toBeSent": "Invitationer, der skal sendes",
        "noInvitationsToBeSent": "Ingen invitationer",
        "removeEmailConfirmation": "Er du sikker på, at du vil fjerne denne e-mail fra listen?",
        "yes": "Ja",
        "no": "Nej",
        "foundByEmail": "Vi har fundet denne person med en matchende e-mail",
        "addToFriendsAndFamily": "Tilføj til venner og familie",
        "alreadyAddedEmail": "Du har allerede tilføjet denne e-mail til listen"
    },
    "pointsCurrencyAdditionalInfo": "Dine %{points_name} og niveauer starter på ny hver %{period}. Alle dine registrerede aktiviteter bidrager til dit samlede niveau i perioden.",
    "rankLabel": "Rang",
    "leaderboards": {
        "loadingLabel": "Indlæser ranglister... Det kan tage et par minutter - det ser ud til, at alle er ude og være aktive!"
    },
    "feeds": {
        "emptyListHomePage": "Der er ingen indlæg at vise endnu. Prøv at justere strømmen for at vise flere indlæg.",
        "viewingPostsFrom": "Visning af indlæg fra",
        "postActivity": "Tilføj en kommentar eller et foto om dine aktiviteter!",
        "indicatorLoader": {
            "defaultTitle": "Opdatering...",
            "successfulLoadedTitle": "Synkroniseret og genopfrisket..."
        },
        "inapropriateTextError": {
            "message": "Indholdet i din besked kan være upassende. Prøv venligst at bruge et mere venligt sprog."
        },
        "postImageError": {
            "title": "Beklager, vi kan ikke sende dette",
            "message": "Det billede, du har tilføjet, er muligvis upassende. Prøv venligst et andet."
        }
    },
    "syncModal": {
        "connect": {
            "title": "Forbindelse med %{name}",
            "description": "For at forbinde dine %{name}-data med din konto skal du udføre følgende trin:",
            "firstStep": "Download og installer %{appName} mobilapplikationen fra %{storeName}",
            "fourthStep": "Vælg at forbinde med %{name}",
            "fifthStep": "Når du bliver bedt om det, skal du vælge de helbredsmålinger, der skal synkroniseres med %{appName}, og trykke på \"Udført\".",
            "additionalInfo": "Bemærk, at %{appName} skal være åbnet for at udløse synkronisering fra appen Sundhed for at kunne udløse synkronisering fra appen Sundhed. Du behøver ikke at holde appen åben, men det kan tage en time, før synkroniseringen er afsluttet og vises i din aktivitetslog."
        },
        "title": "Synkronisering af %{name}",
        "description": "Hvis du vil synkronisere dine %{name}-data med din konto, skal du udføre følgende trin:",
        "steps": {
            "one": "Log ind på din %{appName}-app på din telefon",
            "two": "Åbn afsnittet Apps og enheder i din profil",
            "three": "Tryk på synkroniseringsknappen ved siden af %{name}",
            "iPhone": "Log ind på din %{appName}-app på din iPhone"
        }
    },
    "accountLinkingToast": {
        "success": {
            "title": "Arbejdskonto",
            "message": "Konto forbundet med succes"
        },
        "danger": {
            "message": "Fejl ved tilslutning af konto"
        },
        "conflict": {
            "message": "Kontoen er allerede knyttet til en anden bruger"
        }
    },
    "accountUnlinkingToast": {
        "success": {
            "title": "Arbejdskonto",
            "message": "Konto blev afbrudt med succes"
        },
        "danger": {
            "title": "Link konti",
            "message": "Fejl ved frakobling af konto"
        }
    },
    "earnMoreWithPartners": "Tjen mere med partnere",
    "connectPartnersToEarnByShopping": "Forbind dine konti, og tjen mere %{unit_type} ved at handle med %{program_name} partnere.",
    "viewAllPartners": "Vis alle partnere",
    "myPartnerMemberships": "Mine partnermedlemskaber",
    "linkAccount": "Link medlemskab",
    "linkToPartner": "Link til partner",
    "linkingError": "Der var et problem med at forbinde din konto. Prøv venligst igen.",
    "linkPending": "Link i vente",
    "unlinkAccount": "Fjern link til konto",
    "linkedToPartnerName": "Tilknyttet %{partner_name}",
    "linked": "Linket",
    "permission": {
        "facebookTitle": "Tilmeld dig med Facebook",
        "googleTitle": "Tilmeld dig med Google",
        "facebookDescription": "Når du tilmelder dig med Facebook, skal du give vores teknologipartner \"Sprout\" tilladelse til at få adgang til din identitet og oprette din %{programName}-konto.",
        "googleDescription": "Når du tilmelder dig med Google, skal du give vores teknologipartner \"Sprout\" tilladelse til at få adgang til din identitet og oprette din %{programName}-konto.",
        "camera": {
            "title": "Adgang til kamera",
            "description": "Der kræves kameraadgang for at tage et billede. Tryk på %{appName} i iPhone-indstillingerne, og slå Kamera til.\n\nBemærk, at du kan miste eventuelle uopbevarede ændringer."
        },
        "notNow": "Ikke nu",
        "openSettings": "Åbn indstillinger",
        "photos": {
            "title": "Tillad venligst adgang til foto",
            "description": "Dette giver dig mulighed for at dele fotos fra dit bibliotek og gemme fotos i din kamerarulle. Tryk på %{appName} i iPhone-indstillingerne, og slå Fotos til Læs og skriv.\n\nBemærk, at du muligvis mister eventuelle uopbevarede ændringer."
        }
    },
    "firstNameContainsSpecialChar": "Dit fornavn må kun indeholde engelske bogstaver, bindestreger -, og apostroffer",
    "lastNameContainsSpecialChar": "Dit efternavn må kun indeholde engelske bogstaver, bindestreger - og apostroffer '",
    "goToPartnerSite": "Gå til partnerwebsted",
    "noPartnersFound": "Ingen partnere fundet",
    "noLinkedPartners": "Ingen tilknyttede partnere",
    "noPartnersInCategory": "Ingen partnere i kategorien",
    "partnerAccountPendingVerification": "Kontobekræftelse afventer",
    "shopWithPartner": "Køb med partner",
    "shopWithPartnerName": "Shop med %{partner_name}",
    "linkToPartnerName": "Link til %{partner_name}",
    "earnPartnerMembershipIdentifier": "Identifikator for medlemskab",
    "earnPartnerAccountPendingAddLink": "Dit medlemskab er ved at blive knyttet og kan tage flere dage at gennemføre.",
    "earnPartnerAccountPendingRemoveLink": "Dit medlemskab er ved at blive ophævet og kan tage flere dage at gennemføre.",
    "linkStatusUpdating": "Opdatering af linkstatus",
    "activityTracking": {
        "firstActivityModal": {
            "description1": "Tillykke med at du har tilføjet dine første aktiviteter! \n\nHvis du ønsker det, kan du tilføje flere aktiviteter for i dag og andre dage. Når du er færdig med aktiviteterne i dag, skal du trykke på",
            "description2": "på det næste skærmbillede, når du ikke har mere at spore."
        },
        "listTitle": "Aktiviteter sporet den",
        "dots": {
            "tracked": "Aktiviteter, der blev registreret denne dag",
            "added": "Aktiviteter er blevet tilføjet og afventer indsendelse"
        },
        "trackedActivitiesFor": "Spores aktiviteter for %{date}",
        "activityTracking": "Sporing af aktiviteter",
        "addedPending": "Tilføjet (afventer indsendelse)",
        "search": {
            "description1": "Tryk på",
            "description2": "for at se tilgængelige aktiviteter eller søge efter en bestemt aktivitet"
        },
        "addActivity": "Tilføj aktivitet",
        "addAnotherActivity": "Tilføj en anden aktivitet"
    },
    "rewardsBalance": "%{currencyName} saldo: %{points}",
    "membershipIdentifierRequiredError": "Din medlemskabsidentifikator er nødvendig for at knytte",
    "incorrectValueInRange": "Indtast venligst en værdi mellem %{min} og %{max}",
    "joinTeam": {
        "title": "Deltag i teamet",
        "createInsteadText": "Tilmeld dig eller opret et hold for at deltage i denne udfordring"
    },
    "teamRank": "Holdets rang",
    "teamScore": "Holdets score",
    "appsDevices": {
        "infoText": "Du vil blive bedt om at give vores teknologipartner Sprout Wellness Solutions, Inc. tilladelse til at få adgang til dine trivselsdata, når du tilføjer en app eller enhed.",
        "connectModal": {
            "title": "Godkendelse",
            "paragraph1Part1": "Du vil blive bedt om at give vores teknologipartner tilladelse til at",
            "paragraph1Part2": "Sprout Wellness Solutions, Inc.",
            "paragraph1Part3": "for at få adgang til dine trivselsdata.",
            "paragraph2Desc1": "Din tilladelse giver mulighed for",
            "paragraph2Desc2": "Spire",
            "paragraph2Desc3": "til sikkert at synkronisere dine",
            "paragraph2Desc4": "data med",
            "paragraph2Desc5": ", og hjælper dig med at tjene flere %{pointsName}!"
        },
        "statusAlert": {
            "connectMessage": "Tilslut en app eller en aktivitetssporingsenhed, og gør aktivitetssynkronisering og -sporing til en leg",
            "connectAction": "Tilslut en app eller enhed",
            "errorMessage": "Nogle af dine tilsluttede apps eller enheder kan ikke synkroniseres",
            "warningMessage": "Nogle af dine tilsluttede apps eller enheder har muligvis et forbindelsesproblem",
            "errorAction": "Retter denne fejl",
            "warningAction": "Retter denne advarsel",
            "syncingError": "Synkroniseringsfejl",
            "syncingIssue": "Synkroniseringsproblem"
        },
        "deviceDetails": {
            "warningMessage": "Denne app eller enhed har problemer med at synkronisere",
            "errorMessage": "Denne app eller enhed kan ikke synkronisere",
            "warningAction": "Afvis advarsel",
            "noActivities": "Ingen %{deviceName}-aktiviteter er blevet synkroniseret med %{programName} i de sidste 7 dage. \n\nDet kan tage op til en time, før aktiviteter vises her, efter at de er blevet sporet med %{enhedsnavn}.\n\nHvis du har en anden app eller enhed tilsluttet, og der er blevet sporet flere skridt af den anden app eller enhed, vil du se aktiviteten der. Ellers kan du prøve at afbryde forbindelsen og genforbinde %{enhedsnavn}. Hvis du bliver bedt om at godkende dig eller give tilladelser, skal du sikre dig, at du aktiverer aktivitetsdata og bruger den samme konto til at godkende dig som den, der bruges til at spore aktiviteterne. Se trinene til fejlfinding for at få flere oplysninger.  "
        },
        "troubleshooting": "Fejlfinding",
        "deviceItem": {
            "error": "Forbindelsesfejl",
            "warning": "Advarsel om forbindelse",
            "unableToSync": "Kan ikke synkroniseres"
        },
        "platformDevice": {
            "defaultApp": "Din enheds standard sundhedsapp er",
            "continueMore": "Fortsæt til flere apps og enheder"
        }
    },
    "friendsAndFamily": {
        "learnMore": "Få mere at vide om venner og familie",
        "learnModal": {
            "title": "Om venner og familie",
            "description": "Når du har tilføjet en person til dine venner og familie, kan du vælge kun at dele dine indlæg på %{programName} med dem.\n\nDu kan også filtrere de indlæg, du ser på %{programName}, til kun at blive vist til de personer på din liste over venner og familie, hvis de har skrevet til alle eller til dig.",
            "description_line1": "Når du har tilføjet en person til dine venner og familie, kan du vælge at dele dine indlæg på %{programName} kun med dem.",
            "description_line2": "Du kan også filtrere de indlæg, du ser på %{programName}, til kun at blive vist til de personer på din venneliste, hvis de har sendt indlæg til alle eller til dig.",
            "whatIconsMean": "Hvad ikonerne betyder",
            "canAdd": "Tilføj",
            "added": "Tilføjet"
        },
        "searchDescription1": "Søg efter personer, som du kan tilføje til dine venner og familie.",
        "searchDescription2": "Kan du ikke se, hvem du leder efter? Inviter dem til at deltage via e-mail.",
        "friends&Family": "Venner og familie",
        "managingTour": {
            "title": "Administration af venner og familie",
            "body": "Hvis du vil fjerne en person fra dine venner og familie, skal du trykke på ikonet"
        },
        "removeOption": "Fjern fra venner og familie",
        "inviteDescription1": "Søg efter dine venner og familie.",
        "inviteDescription2": "Kan du ikke se, hvem du leder efter?"
    },
    "deletePlatformInvitationToast": {
        "success": {
            "message": "De indlæg, som du kun deler med venner og familie, vil ikke længere være synlige for %{userFirstName}."
        }
    },
    "skipAll": "Spring alle over",
    "smallMin": "min",
    "eap": {
        "skipModal": {
            "title": "Er du sikker?",
            "description": "Du kan altid kontakte Employee & Family Assistance Program fra din profil, når du har brug for det."
        },
        "contact": {
            "whatIsBestNumber": "Hvad er det bedste nummer at kontakte dig på?",
            "whatIsBestTime": "Hvad er det bedste tidspunkt at kontakte dig på?",
            "morning": "Morgen",
            "afternoon": "Eftermiddag",
            "evening": "Aften",
            "additionalDetails": "Yderligere oplysninger om det tidspunkt\/den dato, hvor du ønsker at blive kontaktet",
            "message": "Kontakt mig i %{weekDay} på %{phoneNumber}. Yderligere oplysninger: %{additional}",
            "description": "Bemærk: Vi anbefaler på det kraftigste, at du vælger et tidspunkt uden for dine arbejdstider og vælger et sted, hvor du vil kunne have en privat samtale. Angiv venligst din tidszone."
        },
        "phoneNumber": {
            "empty": "Dette felt må ikke være tomt",
            "missingDigits": "Telefonnummeret skal indeholde mindst 4 cifre"
        },
        "myEAP": "Mit hjælpeprogram for medarbejdere og familie"
    },
    "healthSurveySkipAllTitle": "Spring over trivselsundersøgelse",
    "healthSurveySkipAllAlert": "Er du sikker på, at du ønsker at springe alle de resterende spørgsmål i trivselsundersøgelsen over?",
    "eapSavingWithoutDataToast": {
        "danger": {
            "title": "Støtteprogram for medarbejdere og familier",
            "message": "Angiv venligst dit telefonnummer og det bedste tidspunkt for kontakt"
        }
    },
    "allMyChallenges": "Mine udfordringer",
    "invitedChallenges": "Invitationer",
    "companyChallenges": "Virksomhedsudfordringer",
    "completedChallengesEmpty": "Det ser ud til, at du ikke har gennemført nogen udfordringer endnu.",
    "myChallengesEmpty": "Det ser ud til, at du ikke har tilmeldt dig nogen udfordringer endnu.",
    "allChallengesEmpty": "Der er ingen udfordringer.",
    "startsToday": "Begynder i dag",
    "startedDaysAgo": "Startede for %{dayCount} dage siden",
    "startsInDays": "Begynder om %{dayCount} dage",
    "privacyOn": "Off",
    "privacyOff": "På",
    "dashboard": {
        "viewLeaderboard": "Se leaderboard",
        "timePeriodProgress": "Dine fremskridt denne %{period}",
        "howToEarn": "Sådan optjener du point"
    },
    "privacyChangeConfirmationMessage": "Ændre privatlivets fred?",
    "privacySettingsTitle": "Privatliv",
    "privacySettingsDescription": "Du kan kontrollere, om dit billede, dit navn og din profil er synlige for andre brugere. ",
    "mainLeaderBoardSettingsTitle": "?samlet rangliste",
    "challengeLeaderBoardSettingsTitle": "?udfordringsrangliste",
    "managePrivacySettingUrlTitle": "Administrer indstillinger for beskyttelse af personlige oplysninger",
    "onboardingFamilyPrivacySettingsMessageOn": "Du er synlig i søgeresultater for venner og familie. Du kan vælge at skjule dig selv fra søgeresultaterne.",
    "onboardingFamilyPrivacySettingsMessageOff": "Dine privatlivsindstillinger skjuler dig i øjeblikket i søgeresultater for venner og familie.",
    "challengeInvitationPrivacySettingsMessageOn": "Du er synlig i søgeresultater for invitationer til udfordringer. Du kan vælge at skjule dig selv fra søgeresultater.",
    "challengeInvitationPrivacySettingsMessageOff": "Dine indstillinger for beskyttelse af personlige oplysninger skjuler dig i øjeblikket i søgeresultaterne for invitationer til udfordringer.",
    "challengeParticipationPrivacySettingsMessageOn": "Du er opført som deltager i denne udfordring. Du kan vælge at skjule dig selv som deltager i dine udfordringer.",
    "challengeParticipationPrivacySettingsMessageOff": "Dine indstillinger for beskyttelse af personlige oplysninger skjuler dig i øjeblikket fra deltagerlisten.",
    "communityInvitationPrivacySettingsMessageOn": "Du er synlig i søgeresultaterne for invitationer til fællesskaber. Du kan vælge at skjule dig selv fra søgeresultaterne.",
    "communityInvitationPrivacySettingsMessageOff": "Dine indstillinger for beskyttelse af personlige oplysninger skjuler dig i øjeblikket fra søgeresultaterne for fællesskabsinvitationer.",
    "communityParticipationPrivacySettingsMessageOn": "Du er opført som medlem af dette fællesskab. Du kan vælge at skjule dig selv som medlem fra dine fællesskaber.",
    "communityParticipationPrivacySettingsMessageOff": "Dine indstillinger for beskyttelse af personlige oplysninger skjuler dig i øjeblikket fra medlemslisten.",
    "eventInvitationPrivacySettingsMessageOn": "Du er synlig i søgeresultater for invitationer til begivenheder. Du kan vælge at skjule dig selv fra søgeresultaterne.",
    "eventInvitationPrivacySettingsMessageOff": "Dine indstillinger for beskyttelse af personlige oplysninger skjuler dig i øjeblikket fra søgeresultaterne for invitationer til begivenheder.",
    "eventParticipationPrivacySettingsMessageOn": "Du er opført som deltager i denne begivenhed. Du kan vælge at skjule dig selv som deltager i dine begivenheder.",
    "eventParticipationPrivacySettingsMessageOff": "Dine indstillinger for beskyttelse af personlige oplysninger skjuler dig i øjeblikket fra listen over deltagere.",
    "mainLeaderboardPrivacySettingsMessageOn": "Du vises på de samlede ranglister. Du kan vælge at skjule dig selv, hvilket fjerner din rang, dit billede og dit navn, når andre ser de samlede ranglister.",
    "mainLeaderboardPrivacySettingsMessageOff": "Dine indstillinger for beskyttelse af personlige oplysninger skjuler dig i øjeblikket, når andre ser de samlede ranglister.",
    "challengeLeaderboardPrivacySettingsMessageOn": "Du vises på udfordringsranglisterne. Du kan vælge at skjule dig selv, hvilket vil fjerne din rang, dit billede og dit navn, når andre ser udfordringsranglisterne.",
    "challengeLeaderboardPrivacySettingsMessageOff": "Dine indstillinger for beskyttelse af personlige oplysninger skjuler dig i øjeblikket, når andre ser udfordringsranglister.",
    "thumbsUpConfirmationTitle": "Tommelfinger op",
    "thumbsUpConfirmationDescriptionline1": "Tillykke, du er ved at give din første tommelfinger op og opmuntre andre!",
    "thumbsUpConfirmationDescriptionline2": "Du vil blive inkluderet i listen over personer, der har givet tommelfingre op til dette indlæg, og andre kan se dit billede, dit navn og kan se din profil.",
    "thumbsUpConfirmationButtonOk": "Tommelfinger op",
    "commentToActionInfoTitle": "Hvad kan andre se?",
    "commentToActionMessage": "Når du kommenterer, kan andre se dit billede, dit navn og kan se din profil.",
    "postToActionTitle": "Hvem ser dette indlæg?",
    "postToActionMessageLine1": "Når du opretter et indlæg, kan du styre, hvem der kan se det, og du kan endda skrive det kun til dig selv.",
    "postToActionMessageLine2": "De indlæg, du deler med andre, viser dit billede og navn, og andre kan se din profil.",
    "privateUsersDescriptionChallenge": "Disse deltagere har skjult sig selv fra listen",
    "privateUsersFirstNamePlaceHolderChallenge": "%{n} privat",
    "privateUsersLastNamePlaceHolderChallenge": "deltager(e)",
    "privateUsersDescriptionEvent": "Disse deltager(e) har skjult sig selv fra listen",
    "privateUsersFirstNamePlaceHolderEvent": "%{n} privat",
    "privateUsersLastNamePlaceHolderEvent": "deltager(e)",
    "privateUsersDescriptionCommunity": "Disse deltager(e) har skjult sig selv fra listen",
    "privateUsersFirstNamePlaceHolderCommunity": "%{n} privat",
    "privateUsersLastNamePlaceHolderCommunity": "medlem(mer)",
    "noPrivacySettings": "Ingen privatlivsindstillinger",
    "linkToPartnerNameWebsite": "Link via %{partner_name} websted",
    "linkToPartnerWebsiteUrl": "URL til partnerwebsted",
    "start_end_time": "Start- og sluttidspunkt:",
    "joinCreateTeamPrivacyDisclaimer": "Dit billede, dit navn og din profil vil altid være synlige for alle, når du ser dit hold i en udfordring, også selvom du har ændret dine indstillinger for beskyttelse af personlige oplysninger til Privat.",
    "carouselInstructions": {
        "swipe": "Stryg kortene for at se alle dine mål og udfordringer.",
        "click": "Klik på kortene for at se alle dine mål og udfordringer."
    },
    "achieved": "Opnået",
    "hours": "timer",
    "createCommunityFlow": {
        "navigatorTitle": "Opret fællesskab",
        "stepType": {
            "title": "Synlighed i fællesskabet",
            "subTitle": "Hvem vil kunne se og deltage i fællesskabet?",
            "privateName": "Privat",
            "publicName": "Offentlig",
            "privateDescription": "Kun personer, som du inviterer, kan se eller deltage i fællesskabet",
            "publicDescription": "Alle kan se og deltage i dette fællesskab"
        },
        "stepName": {
            "title": "Navngiv dit fællesskab",
            "subTitle": "Giv dit fællesskab et navn, så folk ved, hvad det handler om.",
            "namePlaceholder": "Navn på fællesskab",
            "noFieldsTitle": "Navn",
            "noFieldsMessage": "Der er ikke angivet noget navn"
        },
        "stepDescription": {
            "title": "Om dit fællesskab",
            "subTitle": "Fortæl andre, hvad dit fællesskab handler om.",
            "descriptionPlaceholder": "Beskrivelse (valgfrit)",
            "noFieldsTitle": "Beskrivelse",
            "noFieldsMessage": "Der er ikke angivet nogen beskrivelse"
        },
        "stepImage": {
            "uploadPhotoButtonTitle": "Tilføj et foto"
        },
        "stepJoin": {
            "title": "Vi fandt lignende samfund",
            "subTitle": "Kunne du tænke dig at deltage i et af disse fællesskaber i stedet?"
        },
        "createNew": "Opret nyt fællesskab"
    },
    "challengeCard": {
        "allActivities": "Alle aktiviteter i",
        "category": "kategori"
    },
    "myLinkedPartners": "Mine tilknyttede partnere",
    "leaderboardPosition": "Samlet placering på leaderboardet",
    "remainingInChallenge": "resterende i udfordringen",
    "todays_progress": "Dagens fremskridt",
    "this_weeks_progress": "Denne uges fremskridt",
    "this_months_progress": "Denne måneds fremskridt",
    "achievement": "resultater",
    "challengeCardHeader": {
        "challenge": "Udfordring",
        "recommended_personal_goals": "Anbefalet personligt mål",
        "personal_goal": "Personligt mål",
        "competition": "Konkurrence",
        "recommended_goals": "Anbefalet mål",
        "team_competition": "Holdkonkurrence",
        "team": "Team"
    },
    "MyMedibank": "Min Medibank",
    "Google": "Google",
    "Facebook": "Facebook",
    "errorEntityTimeMessage": "Sluttidspunktet kan ikke være tidligere end starttidspunktet",
    "company": "Virksomheden",
    "lessThan1DayRemain": "mindre end 1 dag",
    "lessThan1HourRemain": "mindre end 1 time",
    "remainingToday": "resterende i dag",
    "periodEndsDateAndTime": "Perioden slutter %{date}, %{time}",
    "moreToGo": "%{n} mere %{unit} at gå fra",
    "reachedYourGoal": "Du har nået dit mål %{period}!",
    "reachedYourGoalToday": "Du nåede dit mål i dag!",
    "editProfileItemCorrectRange": "Angiv venligst en gyldig %{itemName}-værdi mellem minimumsværdien %{min} og maksimumsværdien %{max}",
    "invalidUrl": "Ugyldig URL",
    "activityLogChanged": {
        "success": "Ændringer til aktiviteten er blevet gemt",
        "info": "Noget gik galt... Prøv venligst igen.",
        "danger": "Noget gik galt... Prøv venligst igen."
    },
    "discardAlert": {
        "createChallenge": "Er du sikker på, at du ønsker at kassere denne %{challengeType}?",
        "inviteByEmail": "Er du sikker på, at du ønsker at kassere ændringerne?",
        "createTeam": "Er du sikker på, at du ønsker at annullere oprettelsen af dette hold?",
        "cancel": "Annuller",
        "confirm": "Ja, kassér"
    },
    "entityInvalidNameError": "Navnet på %{entity} må kun indeholde tal eller strengværdier og må ikke være tomt.",
    "accept": "Accepter",
    "sync_now": "Synkroniser nu",
    "reconnect_device": "Tilslut igen",
    "supported_activities": "Understøttede aktiviteter",
    "recentlySynced_activity": "Senest synkroniseret aktivitet",
    "noSyncedActivity_sevenDays": "Der er ikke blevet synkroniseret nogen aktiviteter i de seneste 7 dage",
    "recentActivityLog": {
        "convertingActivityPoints": "Synkronisering af aktiviteter...",
        "activityMinuteOrTwo": "Dette kan tage et minut eller to...",
        "noNewActivities": "Der er ikke tilføjet nye aktiviteter... Det kan tage op til en time, før nye aktiviteter er synkroniseret."
    },
    "deleteCommunityCheckbox": "Jeg forstår, at dette ikke kan fortrydes",
    "createEvent": {
        "type": {
            "company": "Firmaarrangement",
            "user": "Brugerhændelse",
            "title": "Begivenhedstype"
        },
        "privacy": "Fortrolighed (vis deltagere eller ej)",
        "cost": "Omkostninger",
        "associated": {
            "location": "Tilknyttet sted",
            "department": "Tilknyttet afdeling\/afdeling"
        },
        "maxParticipants": "Max. Deltagere (valgfrit)",
        "errorMessage": {
            "limit": "Kan ikke være større end %{maxValue}",
            "negative": "Kan ikke være en negativ værdi",
            "selectedLocations": "Vælg venligst et eller flere steder"
        },
        "selectLocations": "Valgte steder",
        "createNew": "Opret ny begivenhed"
    },
    "selected": "Valgt",
    "deleteEventButton": "Slet denne begivenhed",
    "notification": {
        "priorityNotification": {
            "title": "Du har ulæste vigtige opdateringer",
            "subtitle": "Tryk på for at læse dem nu",
            "subtitleWeb": "Klik for at læse dem nu"
        },
        "sectionTitle": {
            "priorityUnread": "Ulæste vigtige opdateringer",
            "all": "Alle meddelelser"
        },
        "modalTitle": "Du har %{count} vigtige opdateringer",
        "priorityModalTitle": {
            "defaultTitle": "Se alle opdateringer"
        }
    },
    "createEntity": {
        "cancel": {
            "title": "Annuller %{entity} %{actionType}",
            "message": "Er du sikker på, at du vil annullere %{entity} %{actionType}?"
        },
        "action": {
            "creating": "oprettelse af",
            "editing": "redigering"
        },
        "type": {
            "team": "team",
            "community": "fællesskab",
            "event": "begivenhed",
            "challenge": "udfordring",
            "goal": "mål"
        }
    },
    "publicVisibilitySwitch": {
        "modalTitle": {
            "public": "Gør det offentligt?",
            "private": "Gør det privat?"
        },
        "modalSubtitle": {
            "public": "Hvis du gør denne %{entityType} offentlig, kan alle opdage den og deltage. Er du sikker på, at du ønsker at gøre denne %{entityType} offentlig?",
            "private": "Hvis du gør denne %{entityType} privat, vil den være lukket for, at ingen kan opdage og tilslutte sig den. Er du sikker på, at du ønsker at gøre denne %{entityType} offentlig?"
        },
        "footerButton": {
            "makePublic": "Ja, gør den offentlig",
            "makePrivate": "Ja, gør den privat",
            "keepPrivate": "Bevar den privat",
            "keepPublic": "Behold offentlig"
        },
        "label": {
            "title": "Gør dette til en offentlig %{entityType}",
            "subtitle": "Alle kan se, og alle kan deltage"
        }
    },
    "imageUploader": {
        "changeImageButton": "Ændre billede"
    },
    "copyright": "Copyright © Sprout 2019",
    "samsunghealth_not_available": "Det er ikke muligt at oprette forbindelse til Samsung Health. I appen Sundhed skal du under Datatilladelser sikre dig, at du som minimum har aktiveret tilladelse til trin og har mindst 1 trin sporet.",
    "rewardsHowDoIEarn": "Hvordan tjener jeg %{currencyName}?",
    "unlockAchievements": "Lås op for præstationer",
    "unlockAchievementsDescription": "Spor aktiviteter, optjen %{pointsName}, lås niveauer op, og optjen mere %{currencyName}. Tryk på hver præstation for at se, hvad du skal gøre.",
    "myDay": "Min dag",
    "myGoalsChallengesTasks": "Mine mål, udfordringer og opgaver",
    "yourGoalsChallenges": "Dine mål og udfordringer",
    "mySocialStream": "Indlæg fra fællesskabet",
    "viewAllAchievements": "Se alle resultater",
    "viewAllBonusChallenges": "Se alle bonusudfordringer",
    "newVersionOfAppAvailable": "Ny version tilgængelig! Genindlæs venligst denne side",
    "noBonusChallengesToDisplay": "Der er i øjeblikket ingen bonusudfordringer tilgængelige.",
    "bonusChallenges": "Bonus-udfordringer",
    "reloadAppVersion": "Genindlæs",
    "appname": "Spire",
    "cancel_tracking_confirmation": "Er du sikker på, at du vil fjerne sporing af %{activity_name}?",
    "activity_tracker_instruction_header": "Tryk på en dag for at spore aktiviteter for den dag, eller se, hvad der allerede er blevet sporet.",
    "alertDashboardFunctionalityToBeAdded": "der vil blive tilføjet tekst her for at forklare, hvad en sporingsperiode er, i lighed med hvordan det gøres for loyalitetsprogrammer for flyselskaber, hvor brugerne skal blive ved med at samle \"miles\" i et kalenderår for at få status for næste år.",
    "noNumberEntered": "Indtast mængden af aktivitet",
    "feed": "Stream",
    "home": "Hjem",
    "challenges": "Udfordringer",
    "explore": "Udforsk",
    "rewards": "Belønninger",
    "reward": "belønning",
    "balance": "Min %{programName} belønningssaldo",
    "profile": "Profil",
    "loading": "Indlæser...",
    "me": "Mig",
    "back": "Tilbage",
    "next": "Næste",
    "skip": "Spring over",
    "signup": "Tilmeld dig",
    "signin": "Log ind",
    "signin_maintitle": "Spire",
    "signin_subtitle": "",
    "signinto": "Log ind for at leve bedre",
    "signup_with_medibank": "Tilmeld dig som Medibank-medlem",
    "signup_with_facebook": "Tilmeld dig med Facebook",
    "signup_with_google": "Tilmeld dig med Google",
    "signup_with_email": "Tilmeld dig med e-mail",
    "signin_with_medibank": "Log ind med Min Medibank",
    "signin_with_facebook": "Log ind med Facebook",
    "signin_with_google": "Log ind med Google",
    "signin_with_email": "Log ind med e-mail",
    "signup_heading": "Opret konto",
    "not_a_medibank_member": "Er du ikke medlem af Medibank?",
    "keep_me_signed_in": "Hold mig logget ind",
    "forgotpassword": "Har du glemt din adgangskode?",
    "emailaddress": "E-mail-adresse",
    "password": "Adgangskode",
    "enterEmailAddress": "Indtast din e-mailadresse",
    "enterYourPassword": "Indtast din adgangskode",
    "password_for_error": "adgangskode",
    "reset_password": "Nulstil adgangskode",
    "passwordResetSuccess": "Nulstilling af adgangskode",
    "passwordResetEmailSent": "Hvis vi har en matchende e-mail i vores system, er du blevet sendt en e-mail med instruktioner til nulstilling af adgangskode.",
    "loginerror": "Der er opstået en fejl under logning på:",
    "logincancelled": "Log ind annulleret",
    "part_of_corporate_program": "Er du tilmeldt et virksomhedsprogram?",
    "continue_here": "Fortsæt her",
    "program_name": "Programnavn",
    "error_provide_program_name": "Angiv venligst et programnavn.",
    "program_not_found": "Program ikke fundet",
    "registration_field_email": "E-mail",
    "employeeId": "Medarbejder-id",
    "registration_field_firstName": "Fornavn",
    "registration_field_lastName": "Efternavn",
    "no_first_name": "Intet fornavn",
    "no_last_name": "Intet efternavn",
    "registration_field_password": "Nyt kodeord",
    "no_disclaimer_available": "Ups, der er opstået et problem... Vi kunne ikke hente din organisations vilkår og betingelser. Prøv venligst at registrere igen senere. ",
    "registration_account_not_registered": "Det ser ud til, at du ikke har verificeret din e-mailadresse endnu. Vil du have os til at sende e-mailen igen?",
    "resend_verification_email": "Bekræftelse af e-mail",
    "resend_verification_email_successful": "Vi har sendt din bekræftelses-e-mail igen.",
    "resend_verification_email_unsuccessful": "Ups, der har været et problem ... vi kunne ikke sende bekræftelses-e-mailen igen. Prøv venligst igen.",
    "not_supported": "Dette indlæg kan ikke vises lige nu. Prøv venligst igen senere.",
    "policyAgreeError": "Hvis du vil fortsætte, skal du acceptere vilkårene for tjeneste og privatlivspolitikken.",
    "challenge_completion_bonus": "Afslutningsbonus",
    "me_tabs": {
        "activity": "Aktivitet",
        "bookmarks": "Bogmærker"
    },
    "health_tab": {
        "my_health_score": "Din trivselsscore",
        "overall_health_score_description": "Din trivselsscore er",
        "health_score_explanation": "Din trivselsscore beregnes ud fra dine svar om dit helbred, og hvor aktiv du er. \n\nDin score opdateres hver måned på baggrund af dit aktivitetsniveau. Du kan sætte og gennemføre personlige mål for at forbedre din trivselsscore.",
        "health_score_calculation_failed_onboarding": "Noget gik galt, og vi har ikke været i stand til at hente din trivselsscore. Du kan fortsætte indtil videre, og så snart problemet er løst, opdaterer vi din score."
    },
    "track_activity": "Spor aktivitet",
    "track_an_activity": "Spor en aktivitet",
    "track": "Spor",
    "unable_to_track": "Kan ikke spores",
    "enter_before_track": "Indtast det aktivitetsbeløb, der skal spores",
    "what_to_share": "Hvilken slags opdatering vil du gerne dele?",
    "remove": "Fjern",
    "activity_tracking_description": "Hvor mange %{units} ønsker du at spore?",
    "excessive_submission": "Wow! Du er ved at spore over 2.000 %{customPoints} for %{activity_name}. Du bør måske sikre dig, at det er rigtigt, før du sender det.",
    "on": "på",
    "in": "in",
    "from": "fra",
    "at": "på",
    "no_activities": "Ingen aktiviteter svarede til din søgning.",
    "activity_tracking_desc": "Du skal tilføje et nummer for at fortsætte. Tryk på X i venstre hjørne for at annullere.",
    "activity_tracking_desc2": "Tryk på et vilkårligt sted på aktiviteten for at redigere, tryk på + for at hurtigspore til målet",
    "vital_stats_title": "Om dig",
    "invalid_numeric_response": "Ugyldig",
    "invalid_numeric_response_range": "Dette tal skal være mellem %{minimum} og %{maximum}",
    "search_placeholder": "Søg i biblioteket...",
    "search_activities": "Søg i aktiviteter",
    "searching": "Søgning...",
    "searchEmpty": "Ingen resultater fundet",
    "vital_stats_description": "Fortæl os lidt om dig selv",
    "health_survey_questions": "Spørgsmål til trivselsundersøgelse",
    "health_survey_title": "Fuldføre trivselsundersøgelse",
    "health_survey_results": "Resultater af trivselsundersøgelsen",
    "health_survey_card_desc": "Tag undersøgelsen for at få et øjebliksbillede af dit velbefindende og opstille personlige mål.",
    "apps_devices_title": "Sammenkædning af apps og enheder",
    "apps_devices_card_desc": "Synkroniser dine apps og enheder for at gøre det nemt at optjene %{customPoints}.",
    "interests_title": "Interesser",
    "interests_card_desc": "Fortæl os om dine interesser. Dette vil hjælpe os med at anbefale mål og fællesskaber, der kan være af interesse for dig.",
    "interests_screen_desc": "Hvad er du interesseret i?",
    "health_obj_title": "Mål for velvære",
    "health_obj_card_desc": "Vi synes, det er på tide at sætte nogle mål. Når vi kender dine mål, vil vi kunne give dig bedre anbefalinger. Bare rolig, hvis du skifter mening, kan du nemt foretage ændringer senere i din profil. ",
    "health_obj_screen_desc": "Hvilke områder vil du gerne arbejde med?",
    "my_heatlh_obj": "Mine mål for velvære",
    "health_topic_title": "Emner om velvære",
    "health_topic_card_desc": "Personliggør din oplevelse ved at angive dine trivselsemner.",
    "health_topic_screen_desc": "Hvad er du interesseret i at lære om?",
    "multi_select_check_error": "Vælg mindst 1 mulighed for at fortsætte",
    "my_health_topics": "Mine trivselsemner",
    "build_your_profile": "Opbyg din profil",
    "personalize_title": "Personaliser",
    "personalize_desc": "Personliggør din oplevelse ved at besvare et par hurtige spørgsmål.",
    "set_goals_title": "Se anbefalede mål",
    "set_goals_desc": "Sæt personlige mål for at komme i gang på din vej til bedre sundhed.",
    "set_this_goal": "Sæt dette mål",
    "goal_set": "Indstillet mål",
    "required": "Påkrævet",
    "apps_devices_description": "Opret forbindelse til en fitnessplatform for automatisk at optjene flere %{customPoints}.",
    "connected": "Tilsluttet",
    "num_connected": "(%{numDevices} connected)",
    "available": "Ledig",
    "inProgress": "I gang...",
    "time_a_m": "am",
    "time_p_m": "pm",
    "last_synced": "Sidst synkroniseret",
    "last_synced_lc": "sidst synkroniseret",
    "no_connected_devices": "Ingen tilsluttede enheder",
    "apps_devices_confirm_disconnect": "Er du sikker på, at du ønsker at afbryde forbindelsen",
    "button_delete": "Slet",
    "button_disconnect": "Afbryd forbindelsen",
    "button_cancel": "Annuller",
    "button_dismiss": "Fjern",
    "ok": "OK",
    "waist_helper_text": "Taljemålet skal tages under ribbenene, normalt i niveau med navlen, og mens du står. Hvis du er usikker, skal du bruge din jeansstørrelse.",
    "apps_devices_manage": "Administrer mine apps og enheder",
    "my_apps_devices": "Mine apps og enheder",
    "completeRegistration": "Gennemfør registrering",
    "havingTrouble": "Har du problemer?",
    "contactUs": "Kontakt support@sproutatwork.com for at få hjælp",
    "done": "Færdig",
    "brand": "Spire",
    "cannotTrackTitle": "Kan ikke spore aktivitet",
    "cannotTrackPrior": "Hovsa. Aktiviteter kan kun spores efter startdatoen.",
    "cannotTrackFuture": "Ikke så hurtigt. Aktiviteter kan kun spores op til den aktuelle dag.",
    "cannotTrack": "Aktiviteter kan ikke spores før en startdato eller for en dag i fremtiden.",
    "disclaimer": "Ansvarsfraskrivelse",
    "acceptTerms": "Jeg accepterer vilkårene og betingelserne",
    "verificationEmailTitle": "Bekræft din e-mail",
    "email_not_yet_verified": "Det ser ud til, at du ikke har bekræftet din e-mailadresse endnu. ",
    "email_successfully_verified_title": "Velkommen",
    "email_successfully_verified": "Det er lykkedes dig at bekræfte din e-mailadresse",
    "pleaseVerifyEmailMessage1": "Du skal bekræfte din e-mailadresse for at fortsætte.",
    "pleaseVerifyEmailMessage2": "Følg venligst de instruktioner, der er sendt til:",
    "supportEmail": "support@sproutatwork.com",
    "resendEmail": "Send e-mail igen",
    "restart": "Tilbage til login",
    "firstName": "Fornavn",
    "firstNamePlaceholder": "Dit fornavn",
    "lastName": "Efternavn",
    "lastNamePlaceholder": "Dit efternavn",
    "email": "E-mail",
    "emailPlaceholder": "Din e-mail-adresse",
    "employeId": "Medarbejder-id",
    "employeIdPlaceholder": "Virksomhedens medarbejder-id",
    "passwordPlaceholder": "Nyt kodeord",
    "datePickerTitle": "Vælg din fødselsdato",
    "datePickerConfirm": "Bekræft",
    "datePickerCancel": "Annuller",
    "termsOfUsePrivacyPreLinks": "Jeg accepterer",
    "sendMePromoCommunications": "Send mig salgsfremmende kommunikation",
    "sendMePromoCommunicationsFromPartners": "Send mig salgsfremmende kommunikation fra partnere",
    "termsOfService": "vilkår for service",
    "legal": "Lovlige",
    "privacyPolicy": "politik om beskyttelse af personlige oplysninger",
    "and": "og",
    "programDomainLabel": "Programnavn",
    "programDomainPlaceholder": "Programnavn",
    "findProgramName": "Find mit programnavn",
    "findProgramNameButton": "Find programnavn",
    "findProgramNameTitle": "Find mit programnavn",
    "findProgramNameDescription": "Virksomhedens e-mail-adresse",
    "findProgramNamePlaceholder": "E-mail-adresse",
    "findProgramSuccessMessage": "Resultaterne af søgningen efter programnavn er blevet sendt til dig via e-mail.",
    "findProgramSuccessTitle": "Programnavn",
    "findProgramErrorTitle": "Programnavn",
    "findProgramErrorMessage": "Ups, der er opstået et problem... Vi er stødt på en fejl, da vi forsøgte at hente dit programnavn. Prøv venligst igen.",
    "countryLabel": "Vælg land",
    "countryName": "Land",
    "regionLabel": "Vælg region",
    "regionName": "Område",
    "cityLabel": "Vælg by",
    "cityName": "By",
    "locationWorkLabel": "Vælg sted",
    "locationWorkName": "Beliggenhed",
    "locationLabel": "Vælg sted",
    "locationName": "Beliggenhed",
    "departmentLabel": "Vælg afdeling\/afdeling",
    "departmentName": "Afdeling\/afdeling",
    "no_department": "Ingen afdeling\/afdeling",
    "enterPIN": "Indtast venligst din virksomheds PIN-kode",
    "verifyEmailTitle": "Bekræftelse af e-mail",
    "verifyEmailMsg": "Det ser ud til, at du ikke har bekræftet din e-mailadresse endnu",
    "resendEmailTitle": "Bekræftelse af e-mail",
    "resendEmailMsg": "Videresendt til %{userEmail}",
    "select_date": "Vælg en dato",
    "changePasswordTitle": "Ændre adgangskode",
    "currentPassword": "Nuværende adgangskode",
    "newPassword": "Nyt kodeord",
    "confirmNewPassword": "Bekræft nyt kodeord",
    "passwordChangeError": {
        "currentPasswordMissing": "Indtast din nuværende adgangskode",
        "newPasswordMissing": "Indtast din nye adgangskode",
        "confirmPasswordMissing": "Bekræft din nye adgangskode",
        "passwordsMatch": "Adgangskoderne passer ikke sammen",
        "passwordIncorrect": "Forkert adgangskode. Prøv venligst igen."
    },
    "settings": "Indstillinger",
    "signOut": "Log ud",
    "updateApp": "Opdater app",
    "updateAppRight": "Nuværende: %{version}",
    "appleStoreUrlSprout": "https:\/\/itunes.apple.com\/us\/app\/sprout-at-work\/id904741273",
    "playStoreUrlSprout": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.sproutmobileapp",
    "appleStoreUrlLiveBetter": "https:\/\/itunes.apple.com\/us\/app\/live-better\/id1289314646",
    "playStoreUrlLiveBetter": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.livebetter",
    "appleStoreUrlTelus": "",
    "playStoreUrlTelus": "",
    "appleStoreUrlUPnGO": "https:\/\/itunes.apple.com\/us\/app\/upngo-with-participaction\/id1079958142",
    "playStoreUrlUPnGO": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.upngo",
    "getHelp": "Få hjælp",
    "feedback": "Feedback",
    "feedback_success_title": "Indsendt feedback",
    "feedback_success_msg": "Tak for din feedback, vi sætter stor pris på den!",
    "feedback_failure_title": "Fejl",
    "feedback_failure_msg": "Bummer... Der skete en fejl ved indsendelse af din feedback, prøv venligst igen.",
    "submit": "Indsend",
    "feedback_char_limit": "Du har overskredet tegnebegrænsningen.",
    "feedback_char_limit_toast_title": "Meddelelsen er for lang",
    "feedback_char_limit_toast_msg": "Din besked overstiger den maksimale grænse på 2000 tegn.",
    "feedback_char_length_msg_1": "Du har indtastet",
    "feedback_char_length_msg_2": "\/2000 tegn.",
    "feedback_empty_toast_title": "Meddelelse tom",
    "feedback_empty_toast_msg": "Det ser ud til, at du ikke har indtastet noget endnu. Skriv en besked, før du sender.",
    "feedback_email_message": "Meddelelse:",
    "feedback_email_user_id": ", Bruger-ID:",
    "feedback_email_device": ", Enhed:",
    "feedback_email_os_version": ", OS Version:",
    "feedback_email_app_version": ", App-version:",
    "savingUserToast": {
        "success": {
            "title": "Gem ændringer",
            "message": "Profilændringer er gemt"
        },
        "danger": {
            "title": "Fejl opstået",
            "message": "Ups... Vi er stødt på en fejl i forsøget på at gemme dine ændringer, prøv venligst igen."
        }
    },
    "edit_profile_user_error_msg": "Se venligst fejlene, før du forsøger at gemme dine ændringer",
    "edit_profile_location_error": "Du skal angive din placering",
    "edit_profile_department_error": "Du skal angive din afdeling\/afdeling",
    "edit_profile_unspecified_value": "Du skal angive en værdi",
    "edit_profile_value_too_low": "Værdien skal være mere end",
    "edit_profile_value_too_high": "Værdien skal være mindre end",
    "choose_gender": "Vælg køn",
    "activity_tracked_successfuly": "Din aktivitet bliver sporet",
    "multi_activity_tracked_successfully": "Dine aktiviteter bliver sporet",
    "no_activities_tracked": "Ingen aktiviteter sporet",
    "track_activity_to_submit": "Vælg en dato i kalenderen for at spore en aktivitet",
    "last_day": "Sidst",
    "days_remaining": "antal dage tilbage",
    "day_remaining": "resterende dag",
    "days_remaining_this_week": "resterende dage i denne uge",
    "day_remaining_this_week": "resterende dage i denne uge",
    "days_remaining_this_month": "resterende dage i denne måned",
    "day_remaining_this_month": "resterende dage i denne måned",
    "earned_today": "Optjent i dag",
    "earned_this_week": "Optjent i denne uge",
    "earned_this_month": "Optjent i denne måned",
    "earned_in_total": "I alt tjent",
    "goal_completed": "Mål opfyldt,",
    "see_results": "se resultater",
    "pts": "%{customPoints}",
    "of": "af",
    "daily_goal": "Dagligt mål",
    "weekly_goal": "Ugentligt mål",
    "monthly_goal": "Månedligt mål",
    "total_goal": "Samlet målsætning",
    "weeks": "uger",
    "today": "I dag",
    "this_week": "Denne uge",
    "this_month": "Denne måned",
    "overall": "Samlet",
    "level": "Niveau",
    "days_remaining_in_period": "%{remainingDays} resterende dage",
    "days_left_in_period": "%{remainingDays} dage tilbage at spore",
    "pointsToLevel": "Fremskridt mod %{levelName}",
    "levelCompleted": "%{levelName} afsluttet",
    "keepTrackingUntil": "Fortsæt med at spore indtil",
    "activityLevelTitle": "Mit aktivitetsniveau",
    "activityLevelDescription": "Hvor meget tid bruger du på at være mindst moderat aktiv - dvs. når du arbejder hårdt nok til at få pulsen op og svede - i en typisk uge? ",
    "activityLevelUnder60": "Under 60 minutter",
    "activityLevelUnder150": "60 til 150 minutter",
    "activityLevelOver150": "Over 150 minutter",
    "gender_male": "Mand",
    "gender_female": "Kvinde",
    "gender_rather_not_say": "Vil helst ikke oplyse",
    "date_of_birth": "Fødselsdato",
    "height": "Højde",
    "Height": "Højde",
    "weight": "Vægt",
    "waistCircumference": "Taljeomkreds",
    "bloodPressureHg": "Systolisk blodtryk (Den høje værdi ved blodtryksmåling)",
    "bloodPressureMm": "Diastolisk blodtryk (den lave værdi ved blodtryksmåling)",
    "bloodCholesterol": "Samlet kolesterol i blodet",
    "ldl": "Lipoprotein med lav densitet (LDL)",
    "hdl": "Lipoprotein med høj densitet (HDL)",
    "restingHeartRate": "Hvilepuls",
    "percentageBodyFat": "Procentdel kropsfedt",
    "hipCircumference": "Hofteomkreds",
    "bloodGlucose": "Blodsukker",
    "triglycerides": "Triglycerider",
    "error_401_signed_out_message": "Din session er udløbet. Log venligst ind igen.",
    "first_name": "Fornavn",
    "last_name": "Efternavn",
    "preferred_name": "Foretrukket navn",
    "notifications": "Meddelelser",
    "notificationsMarkAllReadButton": "Markér alle meddelelser som læst",
    "notificationsSettingsButton": "Indstillinger",
    "notificationsSettingsTitle": "Meddelelser og e-mails",
    "notificationEmptyMessage": "Du er opdateret med dine notifikationer",
    "priorityModalTitle": "Mine prioriterede meddelelser",
    "remindMeLater": "Mind mig om senere",
    "priorityAdminTitle": "Meddelelse fra din administrator",
    "markAsRead": "Marker som læst",
    "expand": "Tryk for at udvide",
    "collapse": "Tryk for at lukke",
    "takePhoto": "Tag et nyt foto",
    "choosePhoto": "Vælg et foto",
    "deletePhoto": "Slet foto",
    "profileImageChangeErrorTitle": "Fejl opstået",
    "profileImageChangeErrorMessage": "Ups... Noget gik galt med redigeringen af dit foto. Prøv venligst igen.",
    "editProfile": "Rediger profil",
    "postButton": "Lave et opslag",
    "shareYourDayName": "Hvad er du ude på?",
    "greeting": "Hej, %{firstNameDisplay}!",
    "shareAnUpdate": "Hvad er du ude på?",
    "shareYourDaySubtitle": "Hvad er du ude på?",
    "shareAPost": "Del et indlæg",
    "postVisibleTo": "Synlig for",
    "link": "Forbind",
    "photo": "Foto",
    "insertLink": "Tilføj et link til dit indlæg",
    "save": "Gem",
    "sampleLink": "http:\/\/sample.com",
    "shareErrorText": "Du skal tilføje indhold til dit indlæg, før du sender det.",
    "generalErrorTitle": "Indlæg tomt",
    "generalSuccessTitle": "Succes",
    "simplePlaceholder": "Hvad er du ude på?",
    "likesCountLabel": "Tommelfinger op",
    "likesReceivedLabel": "Thumbs up received",
    "commentsCountLabel": "Kommentarer",
    "commentsCountLabelSingular": "Kommentar",
    "likeButton": "Tommelfinger op",
    "commentButton": "Kommentar",
    "seePreviousComments": "Se tidligere kommentarer",
    "addCommentPlaceholder": "Tilføj en kommentar",
    "postCommentButton": "Indsend",
    "seeMoreLongComment": "Se mere",
    "activityPoints": "%{customPoints}",
    "activityLog": "Aktivitetslog",
    "discardPost": "Kassér",
    "discardPostMessage": "Er du sikker på, at du ønsker at kassere dit indlæg?",
    "stream_filter_title": "Stream",
    "stream_filter_screen_desc": "Vælg de indlæg, du ønsker at se i strømmen",
    "stream_filter_selection": "Viser:",
    "moderate": "Markér som upassende",
    "moderateDescription": "Hvis du markerer dette indlæg som upassende, bliver det fjernet, og en administrator får besked.",
    "editPost": "Rediger indlæg",
    "deletePost": "Slet indlæg",
    "deleteComment": "Slet kommentar",
    "editComment": "Rediger kommentar",
    "visibleOnlyToMe": "Kun synligt for mig",
    "joinEvent": "RSVP til begivenhed",
    "joinEventDetail": "Deltag i begivenhed",
    "joinedEvent": "Jeg tager af sted",
    "joiningEventToast": {
        "success": {
            "title": "%{eventName}",
            "messageName": "Du har tilmeldt dig begivenheden",
            "message": "Du har tilmeldt dig denne begivenhed med succes"
        }
    },
    "joinChallenge": "Deltag i udfordringen",
    "viewChallenge": "Se udfordring",
    "joinedChallenge": "Tilmeldt udfordring",
    "joinCommunity": "Tilmeld dig fællesskabet",
    "joinedCommunity": "Tilmeldt fællesskab",
    "joinProgress": "Tilmelding til",
    "joinSuccess": "Tilmeldt",
    "invitePeopleToCommunity": "Inviter folk til fællesskabet",
    "numberOfMembers": "%{num} medlemmer",
    "joinToView": "Tilmeld dig dette fællesskab for at se og skrive til andre medlemmer",
    "numberOfAttendees": "%{num} deltager(e)",
    "numberOfParticipants": "%{num} deltagere",
    "numberOfMembersWithUser": "Dig og %{num} andre medlemmer",
    "numberOfAttendeesWithUser": "Dig og %{num} andre deltagere",
    "numberOfParticipantsWithUser": "Du og %{num} andre deltagere",
    "communityMembers": "%{numberOfMembers} medlem(mer)",
    "communityEvents": "%{numberOfEvents} kommende begivenhed",
    "myEvents": "Mine begivenheder",
    "seeAll": "Se alle",
    "noUpcomingEvents": "Ingen kommende begivenheder. Lad os deltage i en!",
    "myCommunities": "Mine fællesskaber",
    "invitedCommunities": "Inviteret",
    "invitationSendingMessage": "Sender invitationer...",
    "invitationReceivedMessage": "inviterede dig til at deltage i dette",
    "invitationMessage": "Vi vil gerne have dig med i vores fællesskab!",
    "recommendedCommunities": "Anbefalet til dig",
    "leaveCommunity": "Forlad dette fællesskab",
    "leaveTeam": "Er du sikker på, at du ønsker at forlade team",
    "leaveTeamLastMember": "i denne udfordring? Hvis du som det sidste medlem af holdet forlader udfordringen, vil holdet blive slettet.",
    "leaveTeamChallenge": "i denne udfordring?",
    "Oops": "Ups, noget gik galt",
    "editCommunity": "Rediger fællesskab",
    "deleteCommunity": "Slet dette fællesskab",
    "leaveCommunityDescription": "Er du sikker på, at du vil forlade dette fællesskab?",
    "inviteToCommunity": "Inviter til fællesskab",
    "inviteByMembers": "Inviter efter navn",
    "inviteByEmail": "Inviter via e-mail",
    "select_person": "Vælg mindst én person, som du vil invitere",
    "no_users_found": "Hmm... vi kan ikke finde nogen med det navn.",
    "promptJoinCommunities": "Det ser ud til, at du ikke har tilmeldt dig nogen fællesskaber. Tilmeld dig fællesskaber for at engagere dig med andre og dele din rejse.",
    "exploreCommunities": "Udforsk fællesskaber",
    "sendInviteByMembers": "Inviter %{num} personer",
    "sendInviteByEmail": "Send en invitation pr. e-mail",
    "createNewCommunity": "Opret et nyt fællesskab",
    "createCommunity": "Opret fællesskab",
    "uploadCover": "Tilføj et foto",
    "cover": "Dæk",
    "nameOfCommunity": "Navn på fællesskab",
    "whatCommunityAbout": "Hvad handler dette fællesskab om?",
    "companyMembersOnly": "Kun for virksomhedens medlemmer",
    "viewAllButton": "Se alle",
    "communities": "Fællesskaber",
    "contentLibrary": "Bibliotek",
    "events": "Begivenheder",
    "past_events": "Tidligere begivenheder",
    "invitationCommunity": "fællesskab",
    "searchPeople": "Søg personer",
    "enterEmail": "Indtast e-mail",
    "personalMessageToNewInvitees": "Personlig besked til nye inviterede",
    "dangerToastTitle": "Fejl",
    "dangerToastMessage": "Hmm... Noget gik galt. Prøv venligst igen.",
    "successToastTitle": "Succes",
    "successToastMessage": "Handling gennemført",
    "joiningToast": {
        "success": {
            "message": "Du blev medlem"
        }
    },
    "deletingCommentToast": {
        "success": {
            "message": "Kommentar slettet"
        }
    },
    "moderatingCommentToast": {
        "success": {
            "message": "Kommentar markeret som upassende"
        }
    },
    "editingCommentToast": {
        "success": {
            "message": "Kommentar opdateret"
        }
    },
    "gettingLikesToast": {
        "success": {
            "message": "Kommentar opdateret"
        }
    },
    "updatingAvatarToast": {
        "success": {
            "message": "Profilbillede opdateret"
        }
    },
    "deletingAvatarAvatarToast": {
        "success": {
            "message": "Foto foto slettet"
        }
    },
    "creatingStreamToast": {
        "success": {
            "title": "Post til stream",
            "message": "Dit indlæg er blevet oprettet"
        }
    },
    "editingStreamToast": {
        "success": {
            "title": "Rediger indlæg",
            "message": "Dit indlæg er blevet redigeret"
        }
    },
    "deletingPostToast": {
        "success": {
            "title": "Slet indlæg",
            "message": "Dit indlæg er blevet slettet"
        }
    },
    "moderatingPostToast": {
        "success": {
            "title": "Markere upassende",
            "message": "Indlæg markeret som upassende"
        }
    },
    "markingAllNotificationsToast": {
        "success": {
            "title": "Marker som læst",
            "message": "Alle meddelelser markeret som læst"
        },
        "info": {
            "title": "Marker som læst",
            "message": "Alle notifikationer er allerede blevet markeret som læst."
        },
        "danger": {
            "title": "Marker som læst"
        }
    },
    "markingNotificationToast": {
        "danger": {
            "title": "Meddelelsen kan ikke markeres som læst"
        }
    },
    "changePasswordToast": {
        "success": {
            "title": "Adgangskode opdateret",
            "message": "Log ind med dit nye password"
        },
        "danger": {
            "title": "Opdatér adgangskode",
            "message": "Ups... Noget gik galt, da vi forsøgte at opdatere din adgangskode. Prøv venligst igen."
        }
    },
    "joining": {
        "success": {
            "message": "Du er blevet medlem af %{name}"
        }
    },
    "invitingUsersToast": {
        "success": {
            "title": "Invitationer",
            "message": "Indbydelse(r) er blevet sendt"
        }
    },
    "creatingCommunityToast": {
        "success": {
            "title": "Opret fællesskab",
            "message": "Dit nye fællesskab er blevet oprettet"
        }
    },
    "restartingCustomGoalToast": {
        "success": {
            "message": "Dit mål er blevet genstartet"
        },
        "danger": {
            "message": "Det er ikke muligt at genstarte målet"
        }
    },
    "quit": "Afslut",
    "wellbeing_survey_completed": "Undersøgelse om trivsel afsluttet",
    "wellbeing_survey_completed_message": "Tak, fordi du har udfyldt undersøgelsen. Vi håber, at det har hjulpet dig med at få et indblik i dit velbefindende.",
    "update_wellbeing_score": "Opdater mine svar i undersøgelsen",
    "get_wellbeing_score": "Få din trivselsscore",
    "stats": "Statistik",
    "my_wellbeing_score": "Min trivselsscore",
    "see_details": "Se detaljer",
    "how_score_calculated": "Hvordan er min score beregnet?",
    "contentTitle": "Bibliotek",
    "promoted": "Udvalgte",
    "recommended": "Anbefalet",
    "recommendedForMe": "Anbefalet til mig",
    "recent": "For nylig tilføjet",
    "view": "Udsigt",
    "added": "Tilføjet",
    "more": "mere",
    "openLibrary": "Tag mig med på biblioteket",
    "readToEarn": "Læs for at tjene penge",
    "readArticle": "Åbn link",
    "see_more": "Se mere (%{num})",
    "see_more_activities": "%{num} mere",
    "my_achievements": "Mine præstationer",
    "achievements": "Opnåede resultater",
    "achievement_earned_date": "Optjent: %{date}",
    "achievement_start_date": "Startet: %{date}",
    "achievement_end_date": "Slutter: %{date}",
    "achievement_earned": "Optjent",
    "achievement_start": "Starter",
    "achievement_end": "Slutter",
    "achievement_earned_times": "%{num} gange",
    "achievement_earned_time": "%{num} tid",
    "in_progress": "I gang",
    "date_earned": "Dato for optjening",
    "earned": "Optjent",
    "past_dates_earned_heading": "Tidligere datoer, hvor der er optjent",
    "all": "Alle",
    "eat": "Spis",
    "move": "Bevægelses",
    "feel": "Føl dig",
    "profile_completion": "Gennemførelse af profilen: %{percentage}%",
    "complete_my_profile": "Udfyld din profil",
    "do_following_tasks": "Udfør følgende %{num} opgave(r) for at færdiggøre din profil.",
    "improve_my_score": "Forbedre din score",
    "see_which_goals": "Tjek de mål, du har sat dig for at spise, bevæge dig og føle dig bedre tilpas.",
    "havent_set_goal": "Du har ikke sat et mål endnu.",
    "set_a_goal": "Sæt et mål",
    "set_another_goal": "Sæt et andet mål",
    "set_another_goal_here": "Sæt et andet mål her.",
    "my_recently_tracked_activities": "Mine seneste aktiviteter",
    "a_few_seconds_ago": "for et par sekunder siden",
    "a_day_ago": "for en dag siden",
    "yesterday": "I går",
    "earn": "Optjen",
    "delete_activity_confirmation": "Er du sikker på, at du ønsker at fjerne denne aktivitet?",
    "delete_activity_title": "Fjern %{measurement} af %{activity_name}?",
    "reached_daily_goal": "Du har nået dit mål i dag. Godt gået!",
    "multiple_activity_non_daily_instruction": "Tryk på en aktivitetsrække for at begynde at spore og optjene %{customPoints}!",
    "multiple_activity_daily_instruction": "Tryk på plustegnet for at spore den mængde af en aktivitet, der er nødvendig for at nå dit mål. Tryk på et andet sted på aktivitetsrækken for at spore en hvilken som helst mængde af den pågældende aktivitet.",
    "only_automatic_activities": "De aktiviteter, der bidrager til dette mål, kan kun spores automatisk",
    "only_automatic_activity": "Den aktivitet, der bidrager til dette mål, kan kun spores automatisk",
    "earn_pts_and_reach_goal": "Optjen %{pts} pts og nå dit mål ved at spore %{qty}",
    "earn_pts_for_every": "Optjen %{pts} pts for hver",
    "you_track": "du sporer!",
    "you_have_tracked": "Du har sporet %{qty}",
    "so_far": "indtil videre!",
    "start_goal": "Sæt dette mål",
    "about_this_goal": "Om dette mål",
    "start_date": "Startdato",
    "end_date": "Slutdato",
    "activities": "Aktiviteter",
    "goal": "Mål",
    "instructions": "Instruktioner",
    "daily": "Daglig",
    "weekly": "Ugentligt",
    "monthly": "Månedligt",
    "total": "I alt",
    "week": "Uge",
    "day": "Dag",
    "days": "Dage",
    "month": "Måned",
    "months": "Måneder",
    "progress": "Fremskridt",
    "about": "Om",
    "days_remaining_to_track": "Du har %{num} dage til at spore eventuelle manglende aktiviteter",
    "number_days": "%{num} dage",
    "one_day": "1 dag",
    "points_earned_this_week": "Optjente point i denne uge",
    "points_earned_year": "Optjente point i år til dato",
    "completed": "Afsluttede",
    "what_you_need_to_do": "Hvad du skal gøre",
    "see_all_num": "Se alle %{num}",
    "my_week_progress": "Dine ugentlige fremskridt",
    "my_day_progress": "Dine daglige fremskridt",
    "my_month_progress": "Dine månedlige fremskridt",
    "my_total_progress": "Dine samlede fremskridt",
    "my_overall_progress": "Samlede fremskridt",
    "you_earned": "Du har tjent",
    "of_this_week": "af %{num} i denne uge",
    "of_this_day": "af %{num} i dag",
    "of_this_month": "af %{num} denne måned",
    "of_this_total": "af %{num} i alt",
    "of_this_overall": "af %{num} i alt",
    "remaining_this_week": "resterende i denne uge",
    "remaining_this_month": "resterende i denne måned",
    "remaining_this_total": "resterende",
    "remaining_this_overall": "resterende i alt",
    "view_history": "Se historik",
    "this_goal_is": "Dette mål er",
    "will_run_for": "Vil løbe i",
    "button_unset_goal": "Ikke fastsat mål",
    "button_leave_challenge": "Forlad udfordringen",
    "leaveChallenge": {
        "menu": "Forlad %{challengeName}"
    },
    "deleteChallenge": {
        "menu": "Slet %{challengeName}"
    },
    "unsetGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Du har fjernet dette personlige mål."
        }
    },
    "leaveChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Du har forladt udfordringen."
        }
    },
    "activities_tracked": "Spurgte aktiviteter",
    "recently_tracked_activities": "Seneste registrerede aktiviteter",
    "add": "Tilføj",
    "change_before_track": "Det ser ud til, at du ikke har foretaget nogen ændringer. Rediger mængden af aktiviteter for denne dag, eller afslut uden at foretage ændringer.",
    "havent_tracked_today": "Det ser ud til, at du ikke har sporet nogen aktivitet for denne dag endnu. Start med at søge efter en aktivitet.",
    "cancel_tracking_quantity": "Annuller sporing af %{quantity} af %{activity_name}",
    "points": "%{customPoints}",
    "discard_activity_edits_confirmation": "Når du afslutter, vil redigeringer i din aktivitetshistorik blive kasseret. Er du sikker?",
    "discard_activity_edits_confirmation_date": "Når du afslutter, vil du kassere redigeringer i din aktivitetshistorik for %{date}. Er du sikker?",
    "yes_discard_edits": "Ja, afslut og kassér redigeringer",
    "createGoal": {
        "navigatorTitle": "Opret et personligt mål",
        "navigatorSubtitle": "Trin %{step} af 4"
    },
    "allCommunities": "Alt",
    "deleteCommunityDescription": "Er du sikker på, at du ønsker at slette dette fællesskab?",
    "remaining": "resterende",
    "recommended_goal": "Anbefalet mål",
    "pinError": "PIN-kode %{pin} er ikke gyldig. Prøv venligst igen.",
    "previousPersonalGoals": "Mine gennemførte personlige mål",
    "previousGoalsTitle": "Mine tidligere mål",
    "endedOn": "sluttede den",
    "achievedOfGoal": "Du nåede %{num}% af målet",
    "previousGoalsEmptyMessage": "Du har ingen tidligere mål",
    "emptyListDefaultMessage": "Du har ingen punkter her",
    "myCommunitiesEmpty": "Det ser ud til, at du ikke har tilmeldt dig nogen fællesskaber. Tilmeld dig fællesskaber for at engagere dig med andre og dele din rejse.",
    "discoverMoreCommunities": "Opdag flere fællesskaber",
    "howLong": "Varighed",
    "frequency": "Hyppighed",
    "discard": "Kassér",
    "description": "Beskrivelse",
    "optional": "valgfri",
    "instruction": "Instruktion",
    "name": "Navn",
    "create": "Opret",
    "categories": "Kategorier",
    "uploadPhoto": "Tilføj et foto",
    "delete_goal": "Slet denne %{name}",
    "delete_goal_confirmation": "Er du sikker på, at du ønsker at slette dette mål?",
    "leave_goal_confirmation": "Er du sikker på, at du vil forlade denne udfordring?",
    "creatingCustomGoalToast": {
        "success": {
            "message": "Dit mål er blevet oprettet."
        }
    },
    "defaultSelectMessage": "Vælg venligst en mulighed",
    "search": "Søg på",
    "inTotal": "i alt",
    "State": "Stat",
    "Business unit": "Virksomhedsafdeling",
    "Work location": "Arbejdssted",
    "whenStart": "Hvornår ønsker du at starte?",
    "every": "hver",
    "acceptChallenge": "Accepter udfordring",
    "activity_history_challenge": "Aktivitetshistorik for udfordring",
    "havent_tracked_challenge": "Du har ikke sporet nogen aktiviteter for denne udfordring",
    "earned_lowercase": "optjent",
    "noone_tracked_yet": "Ingen har sporet noget endnu. Begynd at spore for at være i spidsen i denne konkurrence!",
    "you": "Du",
    "your_team": "Mit hold",
    "congrats_first_place": "Tillykke, du er på førstepladsen! Fortsæt det gode arbejde.",
    "leader": "Leader",
    "average": "Gennemsnitlig",
    "show_leader": "Vis leder",
    "show_me": "Vis mig",
    "show_my_team": "Vis mit hold",
    "leaderboard": "Leaderboard",
    "my_team": "Mit hold",
    "remaining_to_track": "resterende at spore",
    "avg": "avg",
    "invite": "inviter",
    "team_members": "Holdkammerater",
    "daysLeft": "Dage tilbage",
    "regionNameLiveBetter": "Stat",
    "locationNameLiveBetter": "Arbejdssted",
    "departmentNameLiveBetter": "Virksomhedsafdeling",
    "regionLabelLiveBetter": "Vælg stat",
    "locationLabelLiveBetter": "Vælg arbejdssted",
    "departmentLabelLiveBetter": "Vælg forretningsenhed",
    "companyLocation": "Arbejdssted",
    "no_location": "Ingen placering",
    "connect": "Forbind",
    "syncing": "Synkronisering",
    "sync": "Synkronisere",
    "havent_tracked_in_a_while": "Ingen nyligt registrerede aktiviteter",
    "contact": "Kontakt",
    "manage": "Administrer",
    "creator": "Skaber",
    "allow_notifications": "Administrer meddelelser",
    "enable_notifications": "Slå notifikationer til",
    "appload": "Vent lige et øjeblik, mens {app_name} opdateres...",
    "sendResetEmail": "Send en e-mail med nulstilling",
    "min": "Min",
    "max": "Max",
    "error_joining_team": "Kan ikke deltage i holdet",
    "cannot_add_to_team": "Ups... Noget gik galt, da vi forsøgte at tilføje dig til dette hold. Det kan være, at holdet har nået sit maksimale antal medlemmer eller ikke længere eksisterer. Hvis der er opstået en anden fejl, skal du prøve igen.",
    "members_needed": "%{num} medlemmer er nødvendige",
    "member_needed": "%{num} medlem er nødvendigt",
    "spots_left": "%{num} pladser tilbage",
    "join": "Tilmeld dig",
    "no_teams_create": "Der er i øjeblikket ingen hold, som du kan deltage på. Hvorfor opretter du ikke et?",
    "number_teams": "%{num} teams",
    "youLowercase": "du",
    "joined_challenge_on_team": "Du har tilmeldt dig en udfordring på hold %{team_name}.",
    "join_team": "Tilmeld dig et hold",
    "former_members": "Tidligere medlemmer",
    "letsGo": "Start",
    "invite_to_team": "Inviter til hold",
    "connectingDeviceToast": {
        "success": {
            "title": "Tilslut en app eller enhed",
            "message": "Succes! Din app eller enhed er tilsluttet."
        },
        "danger": {
            "title": "Tilslut en app eller enhed",
            "message": "Ups... Vi havde et problem med at forbinde denne tjeneste. Prøv venligst igen."
        }
    },
    "disconnectingDeviceToast": {
        "success": {
            "title": "Afbryd en app eller enhed",
            "message": "Det er lykkedes dig at afbryde %{name}."
        },
        "danger": {
            "title": "Afbryd en app eller enhed",
            "message": "Ups... Vi havde et problem med at afbryde forbindelsen til %{name}. Prøv venligst igen."
        }
    },
    "leave_entity_question": "Forlader %{name}?",
    "delete_entity_question": "Slet %{name}?",
    "leave_team_challenge_confirmation": "Er du sikker på, at du vil lade %{name} blive i denne udfordring?",
    "leave_last_team_member": "Hvis du som det sidste medlem af holdet forlader denne udfordring, vil holdet blive slettet.",
    "oops_msg": "Ups... Der opstod en fejl i forsøget på at gennemføre denne handling. Prøv venligst igen.",
    "has_been_created": "Du har deltaget i udfordringen på holdet %{name}.",
    "specify_team_name": "Angiv venligst et holdnavn",
    "invite_members": "Inviter medlemmer",
    "upload_photo_no_question": "Tilføj et foto",
    "my_progress": "Mine fremskridt",
    "rewardsPointsAdditionalInfo": "Optjen %{reward_currency} for hvert niveau, der nås hver %{period}. Dine %{customPoints} og niveauer starter på ny hver %{period}, så du har mulighed for at fortsætte med at tjene %{reward_currency}, selv om du nåede det højeste niveau i sidste periode.",
    "rewardsPointsInfo": "Dine %{customPoints} og fremskridt nulstilles hver %{period}.",
    "departments": "Afdelinger\/afdelinger",
    "regions": "Regioner",
    "noItemsSelected": "Ingen emner valgt",
    "pleaseSelectOne": "Vælg mindst et emne fra listen",
    "tracked": "Sporet",
    "starts": "Starter",
    "duration": "Varighed",
    "bonus": "Bonus",
    "invited_by": "Inviteret af",
    "create_team": "Opret et hold",
    "discardConfirmation": "Er du sikker på, at du ønsker at afslutte?",
    "discardYes": "Ja",
    "discardStay": "Gå tilbage",
    "create_team_toast_title": "Opret team",
    "edit_team": "Rediger team",
    "team_edits_submitted": "Dit hold er blevet opdateret.",
    "challenge_ended_still_trackable": "Denne %{type} er afsluttet, heldigvis har du %{num} dage tilbage til at spore!",
    "tracking_period_ended": "Sporingsperioden for denne %{type} er slut.",
    "unlimited": "Ubegrænset",
    "ends_in": "Slutter i",
    "challenge_toast": {
        "success": {
            "join": "Succes!",
            "message": "Du har deltaget i udfordringen med succes."
        },
        "danger": {
            "error": "Fejl",
            "message": "Noget gik galt. Prøv at deltage i udfordringen igen om lidt."
        }
    },
    "members_to_invite": "Medlemmer at invitere",
    "members_to_remove": "Medlemmer at fjerne",
    "myChallenges": "Konkurrencer",
    "upcoming": "Kommende",
    "myPersonalGoals": "Mål",
    "companyCompetitions": "Konkurrencer for virksomheder",
    "communityCompetitions": "Konkurrencer i Fællesskabet",
    "edit_your_team": "Rediger dit hold",
    "emails": "E-mails",
    "CompletedOverall": "Gennemført samlet",
    "TotalEarned": "I alt optjent",
    "notify_header": "Jeg vil gerne have besked:",
    "AdditionalBonus": "Yderligere bonus",
    "goalEndedNotification": "Målet er nået, bliv ved med at presse dig selv!",
    "compEndedNotification": "Konkurrencen er afsluttet, fortsæt med at presse dig selv!",
    "congrats_tracking_first": "Tillykke med at spore din første aktivitet!",
    "keep_tracking": "Fortsæt med at spore din aktivitet for at nå mål og stige i niveau.",
    "understanding_tracking": "Forståelse af sporing",
    "cannot_track_this_day": "Du kan ikke tracke på denne dag.",
    "nothing_tracked_this_day": "Du har endnu ikke sporet denne dag.",
    "tracked_something_this_day": "Du har sporet noget for denne dag.",
    "reached_goal_this_day": "Du har nået dit mål for denne dag (kun for daglige mål).",
    "got_it": "Jeg forstår",
    "notDismissedMultiTitle": "Oversigt over udfordringer",
    "notDismissedMultiSubtitle": "Et par udfordringer er afsluttet. Tag et dybere kig på hver enkelt for at få oplysninger om, hvordan du klarede dig. ",
    "daySummary": "%{userName}, her er et resumé af din dag indtil videre",
    "goals": "Mål",
    "competitions": "Konkurrencer",
    "totalAccumulated": "Samlet akkumuleret",
    "tracking_for_date": "Sporing for %{date}",
    "activity_tracker_instruction": "Tryk for at redigere eller fjerne en manuelt sporet aktivitet",
    "ended": "Afsluttet",
    "notYetAvailableBeta": "Endnu ikke tilgængelig i betaversionen",
    "suggestedGoal": "Foreslået mål",
    "singleFor": "for",
    "seeLessLongComment": "Se mindre",
    "synced_data": "Synkroniserede data:",
    "doThisLater": "Jeg vil gøre det senere",
    "inviteUsers": "Inviter andre til at deltage",
    "cannotTrackAfterDeadline": "Du forsøger at spore en aktivitet for en dato efter tidsfristen for udfordringen.",
    "potentialBonusPoints": {
        "section": {
            "title": "%{potentialBonusPoints} bonus %{customPoints} er tilgængelig for dette mål!",
            "titleNotCompleted": "Du missede %{potentialBonusPoints} bonus %{customPoints} med %{activitytCompletedPercentage}%.",
            "titleCompleted": "Tillykke med det! Du har optjent",
            "titleCompletedBold": "%{potentialBonusPoints} bonus %{customPoints}!",
            "subtitle": "Få mere at vide om bonus %{customPoints}"
        },
        "modal": {
            "title": "Bonus %{customPoints}",
            "desc1": "Vi ved, at ingen er perfekt og ikke kan nå deres mål 100 % af tiden.",
            "desc2": "Derfor giver vi bonus %{customPoints}, når din samlede fremgang er på 85 % eller derover.",
            "desc3": "Alle bonus %{customPoints} tildeles, når målet er afsluttet, og hvis al din sporing foregik fra en tilsluttet app eller enhed, får du dobbelt bonus %{customPoints}!",
            "desc4": "Du vil ikke modtage bonus %{customPoints} for mål, som du forlader før tid."
        },
        "msg": {
            "title": "Dette mål er afsluttet",
            "subtitle": "Målet sluttede den %{goalEndedDate}"
        },
        "msgEnded": {
            "title": "Tiden er gået! Dit mål er afsluttet",
            "subtitle": "Du har %{daysNum} %{daysOrDay} til at spore din aktivitet."
        }
    },
    "finish": "Mål",
    "personalGoal": {
        "all_goals": {
            "selected": "Alle %{maxGoals} mål er sat!",
            "description": "Er dette efter din smag? Du kan erstatte alle mål, hvis du skifter mening. Bare rolig, du vil kunne ophæve dit mål senere.",
            "set": "Alle mål er blevet sat!",
            "action": "Alle er indstillet, klar til at gå!",
            "error": "Lad os nu ikke blive for meget! Hvis du fokuserer på højst 3 strukturerede mål ad gangen, vil du øge sandsynligheden for succes.",
            "errorHeading": "Indstilling af mål"
        },
        "set_more": "Du kan sætte %{maxGoals} flere aktive mål",
        "select_goal": {
            "heading": "Sæt et anbefalet mål eller opret dit eget"
        },
        "set_more_1": "Du kan sætte 1 aktivt mål mere"
    },
    "restartPersonalGoal": "Genstart målet med nye mål",
    "delete_challenge_confirmation": "Er du sikker på, at du vil slette denne udfordring?",
    "personal_goal_unit": "mål",
    "personal_goal_units": "mål",
    "day_summary": {
        "steps_taken": "Tagne skridt",
        "calories_in": "Kalorier i",
        "calories_out": "Kalorier ud",
        "avg_daily": "gennemsnitligt dagligt",
        "most_earned_daily": "mest tjente om dagen"
    },
    "invitedBy": "Inviteret af %{person}",
    "resetPasswordMissingField": "Indtast venligst en e-mail",
    "resetPasswordInvalidValue": "Indtast venligst en gyldig e-mailadresse",
    "resetPasswordNotFound": "Din e-mail kan ikke findes",
    "resetPasswordNotCompleted": "Din anmodning kunne ikke gennemføres",
    "resetGoalInstructions": {
        "start": "Gør %{quantity} %{units} %{units} af %{activity}",
        "additional": ", %{quantity} %{units} %{units} af %{activity}",
        "end": "%{frequency} og optjen %{points} %{customPoints} %{customPoints} %{frequency}"
    },
    "goalSet": {
        "one": "Et mål er sat. Se",
        "two": "To fastsatte mål. Se",
        "three": "Tre mål sat. Se",
        "none": "Ingen mål fastsat. Sæt mål"
    },
    "searchCommunitiesEmpty": "Ingen fællesskaber fundet",
    "searchCommunitiesPlaceholder": "Søg i fællesskaber",
    "updating": "Opdatering...",
    "pts_tracked": "Sporet %{activityName} - %{num} %{customPoints}",
    "improving_wellbeing_score": "Fortsæt det gode arbejde, du er på vej til at forbedre din trivselsscore.",
    "progressHistory": "Historik over fremskridt",
    "privateCommunity": "Dette er et privat fællesskab",
    "do_combo_of_activities": "Udfør en kombination af følgende.",
    "noActivitiesTracked": "Ingen aktiviteter sporet",
    "trackingWithFollowingApps": "Sporing med følgende apps\/enheder",
    "recommendedApps": "Anbefalede apps\/enheder til denne %{challengeType}",
    "collapseWord": "Kollaps",
    "started": "Startet",
    "ends": "Slutter ",
    "do_activities": "Udfør aktiviteter",
    "rewards_placeholder": "Eksempel på belønninger fra butikken, stedholder. Brugerne vil se forskellige produkter, de kan købe, og prisen i %{rewardName}.",
    "personalGoals": {
        "top": {
            "label": "Top"
        },
        "allGoals": "Alle mål",
        "seeMoreCard": {
            "heading": "Kan du ikke se det, du leder efter?",
            "description": "Tag et kig på alle anbefalede mål",
            "button": "Udforsk mål"
        }
    },
    "rewardsNotAvailable": "Belønninger er i øjeblikket ikke tilgængelige i denne betaversion. Når den er tilgængelig, vil du kunne se kataloget og gennemføre en indløsning.",
    "editProfileProvideRestingHeartRate": "Angiv venligst en gyldig hvilepulsværdi på mindst 40",
    "liveBetterHealthInfo": "Vi kører en række programmer og har en række sundhedsindhold, der er designet til at støtte en række sundhedsbehov og hjælpe dig med at opnå Bedre Sundhed. Vi har endnu ikke programmer til alle sundhedstilstande og behov - det arbejder vi på! - men hvis du svarer på følgende spørgsmål, kontakter vi dig, hvis vi identificerer sundhedsprogrammer eller -tjenester, som du kan have gavn af at deltage i og\/eller sender dig evidensbaserede oplysninger, der kan hjælpe dig med at forstå og håndtere dine sundhedsbehov bedre. Bemærk venligst, at vi ikke bruger disse oplysninger til at vurdere, om din forsikring er hensigtsmæssig. Hvis du gerne vil finde ud af, hvad du er dækket af, eller hvis du har spørgsmål om din police, kan du ringe til vores Customer Connect-team på 132 331.",
    "deleteGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Du har slettet målet"
        }
    },
    "deleteChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Du har slettet udfordringen"
        }
    },
    "invitations": "Invitationer",
    "learnMorePeriods": "Få mere at vide om perioder",
    "tracked_by_app_name": "Sporet af %{app_name}",
    "device_required": {
        "text": "Denne %{challengeType} kræver en app eller en enhed",
        "button": "Tilslut en app eller enhed"
    },
    "editingCommunityToast": {
        "success": {
            "title": "Rediger fællesskab",
            "message": "Fællesskab er blevet redigeret"
        }
    },
    "competition": "Konkurrence",
    "close": "Luk",
    "only_automatic_activities_with_device": "Denne %{goal_or_competition}s aktiviteter spores automatisk med dine tilsluttede apps\/enheder.",
    "only_automatic_activity_with_device": "Denne %{goal_or_competition}s aktivitet spores automatisk med dine tilsluttede apps\/enheder.",
    "deletingCommunityToast": {
        "success": {
            "title": "%{name}",
            "message": "Fællesskab slettet"
        }
    },
    "teamSizeMessage": "Dit hold har brug for mindst %{min} personer for at optjene %{customPoints} for udfordringen.",
    "captain": "Kaptajn",
    "inviteOthersToTeam": "Inviter andre til mit hold",
    "loadingMetrics": "Tilslutning til kilder for at opdatere din dag...",
    "aboutTeamSize": {
        "title": "Holdstørrelse",
        "text": "%{min} til %{max}"
    },
    "pointsOverview": "%{customPoints} oversigt",
    "deepLinks": {
        "requestCouldNotBeCompleted": "Din anmodning kunne ikke gennemføres",
        "error": "Fejl"
    },
    "required_lc": "påkrævet",
    "personal": "Personlige oplysninger",
    "biometrics": "Biometriske oplysninger",
    "makeSelection": "Foretag et valg",
    "ask_question_success_msg": "Tak. Vi svarer så hurtigt, som vi kan.",
    "report_issue_success_msg": "Tak. Vi svarer så hurtigt, som vi kan.",
    "ask_question_success_title": "Spørgsmål indsendt",
    "report_issue_success_title": "Teknisk problem indsendt",
    "ask_question_failure_msg": "Bummer... Der skete en fejl ved indsendelse af dit spørgsmål, prøv venligst igen.",
    "report_issue_failure_msg": "Bummer... Der var en fejl i rapporteringen af dit spørgsmål, prøv venligst igen.",
    "notTrackedActivities": "Du har ikke registreret nogen aktiviteter i denne periode",
    "learn": "Lær",
    "Balance": "Balance",
    "details": "Detaljer",
    "Reward": "Belønning",
    "levelsReset": "Niveauer nulstilles om %{remainingDays} dage",
    "redeem": "Indløs",
    "redeemAt": "Indløs til %{points}",
    "needPointsToRedeem": "Du har brug for %{points} mere %{rewardName}.",
    "learnEarnMore": "Lær, hvordan du optjener flere",
    "currency": "SproutBucks",
    "joiningTeamChallengeToast": {
        "success": {
            "title": "Deltag i teamet",
            "message": "Du er blevet medlem af holdet med succes!"
        },
        "danger": {
            "message": "Vi er stødt på en fejl og kunne ikke finde holdet. Det eksisterer måske ikke længere."
        }
    },
    "NoMatchingDeepLinkToast": {
        "danger": {
            "title": "Handling ikke tilgængelig",
            "message": "Din anmodning kunne ikke gennemføres."
        }
    },
    "transactionLog": "Transaktioner",
    "orderHistory": "Ordrer",
    "pointsAvailableToEarn": "%{points} til rådighed til optjening",
    "missedYTD": "%{missed} ikke nået YTD",
    "rewardsDetails": "Belønninger",
    "successfullyRedeemedItem": "Du har indløst denne vare med succes",
    "orderNumber": "Ordrenummer",
    "amountSpent": "Brugt beløb",
    "status": "Status",
    "dateRedeemed": "Dato for indløsning",
    "additionalInformation": "Yderligere oplysninger",
    "shipToAddress": "Send til denne adresse",
    "pointMissedYearToDate": "%{rewardCurrencyName} gik glip af dette år",
    "pointMissedYearToDateDescription": "Når du ikke opnår et niveau inden periodens udløb, betragtes de tilhørende %{rewardCurrencyName}, som du kunne have optjent, som ikke opnået.",
    "NoLibraryContentToast": {
        "info": {
            "title": "Artikel ikke fundet",
            "message": "Kunne ikke finde artiklen. Den er muligvis fjernet eller ikke længere tilgængelig."
        }
    },
    "CommunityNotFoundToast": {
        "danger": {
            "title": "Fællesskab ikke fundet",
            "message": "Kunne ikke finde fællesskabet. Det er muligvis fjernet eller ikke længere tilgængeligt."
        }
    },
    "shippingAddress": "Leverings-\/faktureringsadresse",
    "enterShippingAddress": "Indtast din leverings-\/faktureringsadresse",
    "streetLine": "Gadelinje %{num}",
    "stateProvince": "Delstat\/provins",
    "postcodePostalcodeZip": "Postnummer\/Postnummer\/Zip-kode",
    "phoneNumber": "Telefonnummer",
    "order": "Bestilling",
    "redemptionConfirmation": "Indløsningsbekræftelse",
    "edit": "Rediger",
    "processing": "Behandling",
    "checkIsYouFirst": "Vi skal bare lige tjekke, om det er dig først",
    "discardSomeGoals": "Du har sat nogle mål. Disse mål vil blive kasseret, hvis du fortsætter.",
    "settingGoalsToast": {
        "success": {
            "message": "Dine nye mål er blevet sat!"
        }
    },
    "one_team": "1 hold",
    "noAchievementsToEarnMessage": "Det ser ud til, at der ikke er flere badges at optjene %{rewardCurrencyName} i denne periode.",
    "shopRewards": "Shop belønninger",
    "validateShippingAddressToast": {
        "danger": {
            "title": "Leverings-\/faktureringsadresse",
            "message": "Udfyld venligst alle felter, før du fortsætter."
        }
    },
    "viewDetails": "Se detaljer",
    "potential": "Potentiel",
    "missed": "Savnet",
    "rewardsStoreNotAvailable": "Belønningsbutikken er ikke tilgængelig for dig i øjeblikket.",
    "havent_tracked_in_a_while_date": "Der er ikke registreret nogen aktiviteter for %{currentDate}",
    "challengeNotFoundToast": {
        "danger": {
            "title": "Udfordring ikke fundet",
            "message": "Kunne ikke finde udfordringen. Den er muligvis fjernet eller ikke længere tilgængelig."
        }
    },
    "shareYourDaySubtitleActivity": "Tilføj et billede eller sig noget om denne aktivitet!",
    "goal_ended": "Mål afsluttet",
    "challenge_ended": "Udfordringen er afsluttet",
    "day_remaining_to_track": "Du har 1 dag til at spore eventuelle manglende aktiviteter",
    "challengeGoalCardSubtitleEndDate": "%{challengeOrGoal} sluttede den %{endDate}",
    "goalEndedModal": {
        "title": "Indhente glemte aktiviteter",
        "message": "Når et personligt mål eller en udfordring er afsluttet, har du tre dage fra slutdatoen til at spore eventuelle aktiviteter, du har glemt. Efter denne frist kan du ikke registrere yderligere aktiviteter, der bidrager til målet eller udfordringen."
    },
    "summary": "Resumé",
    "placedRank": "Du er placeret %{rank} af %{total}",
    "rank": {
        "first": "1.",
        "second": "2.",
        "third": "3.",
        "n": "%{rank}th"
    },
    "event_name": "Navn på begivenhed",
    "this_is": "Dette er en  ",
    "location_info": "Sted og info",
    "what_event": "Hvad handler denne begivenhed om",
    "event_is": "Denne begivenhed er",
    "start_on": "Start den:",
    "end_on": "Slut på:",
    "location": "Beliggenhed",
    "chooseLeaderboard": "Vælg et leaderboard",
    "filterOneOfFollowing": "Filtrer et af følgende",
    "showChallengeInstead": "Vis en udfordring i stedet",
    "showActivityInstead": "Vis en aktivitet i stedet",
    "showAll": "Vis alle",
    "activitiesShowSame": "Aktiviteter: %{activityName}",
    "challengeShowSame": "Udfordring: %{challengeName}",
    "chooseTimePeriod": "Vælg en tidsperiode",
    "youCanFilterOneAtTime": "Der kan vælges ét filter ad gangen",
    "saveHealthTopicsToast": {
        "success": {
            "message": "Sundhedsemner gemmes",
            "title": "Succes!"
        },
        "info": {
            "message": "Kan ikke gemmes"
        },
        "danger": {
            "title": "Fejl!"
        }
    },
    "saveHealthObjectivesToast": {
        "success": {
            "message": "Sundhedsmål gemt",
            "title": "Succes!"
        },
        "info": {
            "message": "Kan ikke gemmes"
        },
        "danger": {
            "title": "Fejl!"
        }
    },
    "saveInterestGroupsToast": {
        "success": {
            "message": "Interesser gemt",
            "title": "Succes!"
        },
        "info": {
            "message": "Kan ikke gemmes"
        },
        "danger": {
            "title": "Fejl!"
        }
    },
    "edit_event": "Rediger begivenhed",
    "leave": "Forlade",
    "delete_event": "Slet begivenhed",
    "no_events": "Ingen begivenheder",
    "no_events_placeholder": "Du planlægger ikke at deltage i fremtidige arrangementer i øjeblikket. Hvorfor deltager du ikke i en?",
    "event": "begivenhed  ",
    "challenge": "Udfordring",
    "invited_you": "Inviterede dig",
    "public": "Offentlig",
    "private": "Privat",
    "deleteEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Begivenhed slettet med succes."
        }
    },
    "leaveEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Du har forladt begivenheden"
        }
    },
    "editEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Hændelse opdateret med succes."
        }
    },
    "createEventToast": {
        "success": {
            "message": "Begivenhed oprettet med succes.",
            "title": "%{eventName}"
        }
    },
    "contentIsDeletedOrInappropriate": "Det indhold, du forsøger at se, er ikke tilgængeligt i øjeblikket. Det er muligvis blevet slettet af forfatteren eller markeret som upassende.",
    "start_time": "Starttidspunkt",
    "end_time": "Sluttidspunkt",
    "event_type": "%{eventType} begivenhed",
    "leave_event_modal": {
        "title": "Hvis du forlader denne begivenhed",
        "message": "Den vil blive slettet"
    },
    "leave_event ": "Er du sikker på, at du ønsker at forlade denne begivenhed?",
    "create_event": "Opret begivenhed",
    "created_by": "Oprettet af",
    "eventActionToast": {
        "danger": {
            "title": "Fejl",
            "message": "Noget gik galt. "
        }
    },
    "continue": "Fortsæt",
    "wantExitTour": "Er du sikker på, at du ønsker at afslutte turen?",
    "exitTour": "Afslut tur",
    "deleveEventPopup": "Er du sikker på, at du vil slette denne begivenhed?",
    "attendeesTitle": "Deltagere",
    "userEvents": "%{name}'s begivenheder",
    "createEventIndicator": "Oprettelse af begivenhed",
    "inviteToEvent": "Inviter til begivenhed",
    "noDescription": "Der er ingen beskrivelse.",
    "leaderboardIsEmpty": "Denne rangliste er tom, eller du skal muligvis spore aktivitet inden for den valgte tidsperiode for at se den",
    "notParticipantingInAnyChallenges": "Du deltager ikke i nogen udfordringer",
    "buttonLeaveEvent": "Forlad begivenheden",
    "leaveEvent ": "Forlader %{name}?",
    "canceledCreatingChallenge": "Oprettelse af en %{challengeType} er annulleret med succes",
    "swipeReadNotification": "Læs",
    "productTour": {
        "initialScreen": {
            "title": "Velkommen til %{programName}!",
            "body": "Lad os tage en rundvisning, og om et øjeblik vil du kende det grundlæggende."
        },
        "dashboard": {
            "title": "Dashboard",
            "body": "Se, hvor mange %{pointsName} du har, og dine fremskridt mod niveauer. Tjek derefter leaderboardet for at se, hvordan du ligger i forhold til andre."
        },
        "rewards": {
            "title": "Belønninger",
            "body": "Se, hvor mange %{rewardPointName} du har, og indløs dem i butikken."
        },
        "goals": {
            "title": "Mål og udfordringer",
            "body": "Dine aktive personlige mål, udfordringer med andre og særlige opgaver kan du finde her."
        },
        "explore": {
            "title": "Udforsk",
            "body": "Find udfordringer sammen med andre, deltag i fællesskaber for at diskutere dine interesser, og opdag en ny artikel i velværebiblioteket."
        },
        "me": {
            "title": "Mig",
            "body": "Find din trivselsscore, tjek din statistik, og rediger din profil og dine indstillinger her."
        },
        "finishScreen": {
            "title": "Du er helt klar",
            "body": "Tak, fordi du gennemførte rundvisningen.",
            "button": "Lad os komme igang"
        },
        "skip": {
            "title": "Er du sikker på, at du vil springe turen over?",
            "body": "Dette vil afslutte rundvisningen, og du kan komme i gang med det samme."
        }
    },
    "getTemporaryRewardRedemptionTokenToast": {
        "danger": {
            "title": "Fejl i godkendelsen",
            "message": "Kunne ikke fortsætte med indløsning af belønning. Der opstod en fejl under godkendelsen hos udbyderen af belønningen."
        }
    },
    "rewardRedemptionFailureToast": {
        "danger": {
            "title": "Indløsning mislykkedes",
            "message": "%{displayMessage}"
        }
    },
    "disclamerSectionTitle": "Før du begynder",
    "disclamerSectionMessage": "Kontakt egen læge, før du begynder på et nyt træningsprogram eller foretager livsstilsændringer for at sikre, at de er passende for dig.",
    "noEarchedAchievements": "Du har endnu ikke opnået nogen resultater. Spor en aktivitet for at komme i gang.",
    "noInProgressAchievements": "Du har ingen igangværende resultater.",
    "discardCreatingEventMessage": "Kontroller, at alle obligatoriske felter er blevet indtastet",
    "discardCreatingEventTitle": "Der kan ikke oprettes en begivenhed",
    "discardEditedEventTitle": "Begivenhed kan ikke redigeres",
    "errorEventNameMessage": "Navn er påkrævet",
    "errorEventStartDateMessage": "Startdato er påkrævet",
    "errorEventEndDateMessage": "Slutdato er påkrævet",
    "errorEventDateMessage": "Slutdatoen kan ikke være tidligere end startdatoen",
    "noAccountsToLink": "Der er ingen konti til rådighed til at blive knyttet til %{program_navn}.",
    "accountLinkEmailChanged": "Din e-mail-adresse er blevet opdateret. Fremover skal du logge ind med din tilknyttede konto.",
    "accountLinkSuccessful": "Din konto er blevet forbundet.",
    "edit_profile_nan_value": "Værdien skal være et tal",
    "advancedLogIn": "Avanceret log ind",
    "redemptionSessionExpiredToast": {
        "danger": {
            "title": "Indløsning mislykkedes",
            "message": "Bestillingssessionen er udløbet. Prøv venligst at bestille igen."
        }
    },
    "left": "venstre",
    "eventsCarousel": {
        "emptyEvent": {
            "prompt": "Det ser ud til, at der ikke er nogen begivenheder, som man kan deltage i på dette tidspunkt. Hvorfor opretter du ikke en?"
        }
    },
    "reachedHighestLevel": "Du har nået det højeste niveau!",
    "error": "Fejl",
    "redeemRewardSuccessfulToast": {
        "success": {
            "title": "Indløsning af belønning",
            "message": "Din ordre er blevet afgivet"
        }
    },
    "redeemRewardComplete": "Indløsning gennemført",
    "trackActivityTitle": {
        "oneUnit": "Track: 1 %{unit} af %{activity} på %{date}",
        "nUnit": "Spor: %{activity} for %{date}"
    },
    "ssoAuthenticationFailure": "Fejl i godkendelsen",
    "earnEvery": "Optjen hver %{frequency}",
    "earnOnce": "Optjen kun én gang",
    "goalSettings": {
        "maximumSet": "Du har i øjeblikket maksimalt 3 fastsatte mål.",
        "learnMore": "Få mere at vide om at sætte mål"
    },
    "allowMarketingComms": "Send mig salgsfremmende kommunikation",
    "allowPartnerMarketingComms": "Send mig salgsfremmende kommunikation fra partnere",
    "noUpcomingAchievements": "Du har ingen kommende resultater.",
    "settingGoalToast": {
        "success": {
            "message": "Dit nye mål er blevet sat!"
        }
    },
    "authentication": {
        "saml": {
            "error": "Tjenesten er i øjeblikket ikke tilgængelig",
            "signin": "Integreret log-in",
            "signup": "Integreret tilmelding"
        }
    },
    "monthName": {
        "january": "Januar",
        "february": "Februar",
        "march": "Marts",
        "april": "April",
        "may": "Maj",
        "june": "Juni",
        "july": "Juli",
        "august": "August",
        "september": "September",
        "october": "Oktober",
        "november": "November",
        "december": "December"
    },
    "promotedForMe": "Udvalgte",
    "appRating": {
        "enjoying": "Er du glad for vores app?",
        "feedback": "Vil du give os noget feedback?",
        "appStore": "Bedømme os i App Store?",
        "googlePlay": "Bedøm os på Google Play?",
        "notReally": "Ikke rigtig",
        "yes": "Ja!",
        "sure": "Selvfølgelig",
        "noThanks": "Nej tak",
        "notNow": "Ikke nu"
    },
    "getMobileApp": "Hvis du vil bruge %{programName} på din smartphone, skal du downloade %{appStoreName} fra App Store eller Google Play.",
    "newAppsDevicesDesign": {
        "getMobileApp": "Download %{programName}-appen",
        "searchInAppStore": "Søg efter %{programName} i App Store eller Google Play.",
        "getMobileAppNoName": "Hent appen på mobil"
    },
    "editorAlert": {
        "discardChanges": "Kassér ændringer",
        "saveAndContinue": "Gem og fortsæt",
        "title": "Ikke gemte ændringer",
        "text": "Du har foretaget nogle ændringer, som ikke er blevet gemt. Hvad vil du gerne gøre?"
    },
    "resources": "Ressourcer",
    "noResources": "Ingen ressourcer tilgængelige",
    "viewAllResources": "Se alle ressourcer",
    "language": "Sprog",
    "eventStarted": "Begivenhed startet. Tilmelding lukket.",
    "Gender": "Køn",
    "show": "Vis",
    "hide": "Skjul",
    "timeoutError": "Ups! Der er noget, der tager for lang tid. Prøv venligst igen senere.",
    "SOT": {
        "sample_task": "Eksempel på en opgave"
    },
    "cache": {
        "new_version": "En ny version er tilgængelig!",
        "refresh_browser": "Klik her for at opdatere din browser."
    },
    "welcomeUser": "Velkommen, %{userFirstName}!",
    "quarter": "kvartal",
    "completionReward": "Belønning for afslutning",
    "bronzeLevel": "Bronze-niveau",
    "deviceAppSyncingOk": "Enhed \/ app synkronisering ok",
    "deviceAppSyncingIssue": "Enhed \/ app synkroniseringsproblem",
    "deviceAppSyncingError": "Fejl ved synkronisering af enhed\/app",
    "lastSync": "Sidste synkronisering",
    "period": "periode",
    "yourDaySummary": "Din dag indtil videre",
    "steps": "Trin",
    "gender_non_binary": "Ikke-binær eller andet",
    "take_survey": "Tag undersøgelsen",
    "social": "Social",
    "finalDay": "Sidste dag",
    "leaderboard_position": "Placering på ranglisten",
    "signUp": {
        "apple": {
            "disconnectSettings": "Afbryd %{appName} fra \"Apple ID Password & Security\" i Telefonindstillinger for at fortsætte tilmeldingen"
        }
    },
    "earnPoints": "Optjen %{customPoints}. Niveau op.",
    "getReward": "Få %{rewardName}.",
    "buildHealthyHabits": "Opbyg sunde vaner.",
    "highestLevelIndicator": "Du har nået det højeste niveau!",
    "highestLevelIndicatorNew": "Du har gennemført alle niveauer!",
    "trackYourActivity": "Hvis du vil have %{customPoints}, skal du registrere din motion og dine wellness-aktiviteter.",
    "levelUpToGetRewarded": "Efterhånden som du stiger i niveau, bliver du belønnet med %{rewardName}.",
    "levelUpAndEarn": "Dine fremskridt nulstilles hver %{period}, så du kan stige i niveau og tjene igen og igen.",
    "levelUp": "Dine fremskridt nulstilles hver %{period}, så du kan stige i niveau igen og igen.",
    "goToLibrary": "Gå til biblioteket",
    "updateEventIndicator": "Opdatering af begivenhed",
    "meTour": {
        "healthSurveyDisabled": "Tjek din statistik, og rediger din profil og dine indstillinger her."
    },
    "createNewGoal": "Opret nyt mål",
    "later": "Senere",
    "bonusChallenge": "Bonusudfordring",
    "bonusChallengeInfo": {
        "withReward": "Du optjener %{amount} bonus %{points} for at gennemføre mindst 85 % af denne %{challengeType}.",
        "noReward": "Du får en bonus for at fuldføre mindst 85 % af denne udfordring.",
        "boldText": "%{amount} bonus %{points}",
        "noRewardChallengeType": "Du får en bonus, hvis du gennemfører mindst 85 % af denne %{challengeType}."
    },
    "defaultApp": "Din standard sundhedsapp",
    "bonusGoal": {
        "additionalInfo": "Hvis al din aktivitet er blevet registreret ved hjælp af en tilsluttet app eller enhed, får du dobbelt bonus %{points}!",
        "additionalInfoNew": {
            "paragraph2": "Bonus %{points} tildeles, efter at målet er afsluttet. Du modtager ikke bonus %{points} for mål, som du forlader før tid."
        },
        "boldText": "dobbelt bonus %{points}!",
        "markTitle": "Bonusmål"
    },
    "notify_me": "Giv mig besked",
    "bonusChallengeReward": "Bonus belønning for udfordring",
    "forCompletingChallenge": "For at fuldføre %{challengeName}",
    "notifications_text": "Meddelelser hjælper dig med at holde dig til dine mål og holde dig ajour med samtaler.",
    "type_here": "Skriv her",
    "bonusEarned": "Optjent bonus",
    "youEarnedBonus": "Du har fortjent denne bonus!",
    "inviteOthersToChallenge": "Inviter andre til at deltage i udfordringen",
    "inviteOthersToYourTeam": "Inviter andre til dit hold",
    "manageTeam": "Administrer holdet",
    "ft": "ft",
    "lbs": "lbs",
    "cm": "cm",
    "kg": "kg",
    "community": "fællesskab",
    "chooseActivity": "Vælg aktivitet",
    "Recent": "Seneste",
    "noActivities": "Ingen matchende aktiviteter",
    "photoChooseText": "Vælg",
    "photoCancelText": "Annuller",
    "signIn": {
        "missingEmail": "Manglende e-mail-adresse",
        "missingPassword": "Sørg for, at adgangskoden er angivet",
        "invalidLogin": "Ugyldigt login",
        "accountLocked": "Din konto er låst. Kontakt venligst din administrator",
        "accountMayNotExist": "Vi har ikke en konto for denne e-mailadresse. Tilmeld dig for at oprette en konto.",
        "wrongPassword": "Forkert adgangskode. Prøv igen, eller klik på Glemt adgangskode for at nulstille den."
    },
    "deleteGoalBonusPoints": "Hvis du endnu ikke har optjent den tilhørende bonus, kan du ikke længere gøre det.",
    "havent_tracked_goal": "Du har ikke registreret nogen aktiviteter for dette mål",
    "trackActivity": {
        "search": "Søg aktiviteter...",
        "text": "Spor aktivitet",
        "done": "Færdig",
        "discardChanges": "Afvise ændringer?",
        "discardMessage": "Er du sikker på, at du vil afslutte og kassere dine fremskridt?",
        "discard": "Kassér",
        "limitMessage": "Du kan kun spore op til syv dage ad gangen.",
        "inputDescription": "Mængden af %{activity} for %{date}",
        "gracePeriod": "Du har %{n} %{text} til at spore enhver savnet aktivitet"
    },
    "dates": "Datoer",
    "pickDates": "Vælg andre datoer",
    "selectDates": "Vælg datoer",
    "limitReached": "Du har nået grænsen",
    "activity": "Aktivitet",
    "keepUpTheGoodWork": "Fortsæt det gode arbejde!",
    "activityTracked": "Sporet aktivitet",
    "new": "Ny",
    "newFeatureTitle": "Nemmere og hurtigere sporing af aktiviteter",
    "newFeatureText": "Uanset om du sporer aktivitet fra i dag, fra tidligere eller for flere dage, tror vi, at du vil elske den nye oplevelse.",
    "gotIt": "Jeg forstår!",
    "frequencyViewHistory": "Vis %{frequency} fordeling",
    "challengeDetails": {
        "trackTheseActivities": "Spor en af disse aktiviteter for at gøre fremskridt i forhold til denne %{challengeType}."
    },
    "member": "medlem",
    "weeklyBreakdown": "Ugentlig opdeling",
    "setGoals": {
        "earnPointsText": {
            "start": "Tjen",
            "end": "for at sætte dit første mål!"
        }
    },
    "weeklyGoalEnded": "Ugen sluttede den",
    "weekFinished": "Du afsluttede en uge på",
    "restartGoal": {
        "daysLeftToTrack": "Du har stadig %{quantity} %{days} til at spore eventuelle glemte fremskridt fra sidste uge.",
        "weekEnded": "Denne uge er afsluttet.",
        "timesUp": "Tiden er gået!",
        "period": {
            "title": "Målperiode",
            "text": "Mandag til søndag, hver uge"
        }
    },
    "membersPlural": "Medlemmer",
    "startedADayAgo": "Startede for 1 dag siden",
    "goalRestarted": "Du genstartede dette mål",
    "weeklyGoals": "Ugentlige mål",
    "weeklyGoalsDescription": "Ugentlige mål fornyer sig selv hver mandag, så du kan opretholde en sund vane over en længere periode.",
    "challengeEnded": "Denne %{challengeType} er afsluttet",
    "goalEndedModalTitle": "Tiden er gået! Din %{challengeType} er afsluttet!",
    "yourProgress": "Dine fremskridt",
    "earn_withRewards": "Spor din sunde aktivitet for at tjene (%{pts}) og bestå niveauer. Når du stiger i niveau, får du %{currency}.",
    "earn_noRewards": "Suivez votre exercice et votre activité de bien-être pour gagner (%{pts}) et passer au niveau supérieur.",
    "currentPeriod": "Aktuel periode",
    "currentScore": "Aktuel score",
    "viewActivityLog": "Se aktivitetslogbog",
    "balanceHistory": "Min saldohistorik",
    "mymedibank": {
        "underAge": {
            "error": "Live Better-appen er kun tilgængelig for brugere på 18 år og derover, se Live Better T&Cs for flere oplysninger."
        }
    },
    "enhancedHomePageInfo": "Vi har ryddet op på forsiden! Det er nu nemmere at se dine udfordringer og mål. Tid til at komme i gang med at spore!",
    "levelUpTitle": "Niveau op",
    "levelUpDescription": "Passér niveauer ved at spore aktiviteter og fuldføre mål og udfordringer. Efterhånden som du stiger i niveau, bliver du belønnet med %{currency}!",
    "achievementsDescription": "Lås disse særlige badges op for at tjene %{currency}. Klik på et badge for at se, hvad du skal gøre.",
    "bonusChallengesDescription": "Deltag i og fuldfør udfordringer, der har en %{currency}-bonus.",
    "earnWithPartners": {
        "title": "Tjen med partnere",
        "description": "Medibank-medlemmer med hospitals- eller ekstradækning kan optjene point på berettigede køb\/aktiviteter hos partnere."
    },
    "browseAllPartners": "Gennemse alle partnere",
    "resetsIn": "Nulstilles om %{daysNumber} dage",
    "thisIsALot": "Dette er meget!",
    "areYouSure": "Er du sikker?",
    "trackingALotMessage": {
        "days": "Du sporer over 2.000 %{customPoints} på %{daysNum} dage. Det er ret meget!",
        "day": "Du sporer over 2.000 %{customPoints} på 1 dag. Det er ret meget!"
    },
    "amSure": "Jeg er sikker på, at",
    "activeMinutesAndSleep": {
        "title": "Enhedssporing for aktive minutter og søvn",
        "description": "Din enhed registrerer aktive minutter under fysisk aktivitet med moderat eller høj intensitet—det er motion af god kvalitet! Bruger du en enhed til at spore din søvn? Du optjener også %{points} for det!"
    },
    "hourShort": "hr",
    "hoursShort": "timer",
    "secondsShort": "sek",
    "watchToEarn": "Se for at tjene",
    "oneParticipant": "1 deltager",
    "oneTeam": "1 hold",
    "numberOfTeams": "%{num} teams",
    "inviteToYourTeam": "Inviter til dit hold",
    "inviteToThisChallenge": "Inviter til denne udfordring",
    "challengeInstructionText": "Følg denne aktivitet for at gøre fremskridt i forhold til din %{challengeType}.",
    "showLess": "Vise mindre",
    "startsTomorrow": "Begynder i morgen",
    "deadlineDayLeft": "dag tilbage",
    "deadlineDaysLeft": "dage tilbage",
    "deviceBonus": "enhedsbonus",
    "appsAndDevices": {
        "header": "Apps og enheder",
        "linked": "Disse apps og enheder, der er knyttet til denne %{challengeType}, er sporet til denne %{challengeType}:",
        "noLinked": "Ingen relevante apps eller enheder er knyttet",
        "link": "Forbind din telefon, dit ur eller din app for at spore automatisk."
    },
    "yourGoals": "Dine mål",
    "yourChallenges": "Dine udfordringer",
    "position": "Position",
    "team_success": "Teamets succes",
    "starts_in": "Begynder i",
    "team_challenge": "Holdudfordring",
    "your_progress_today": "Dine fremskridt i dag",
    "your_daily_avarage": "Dit daglige gennemsnit er",
    "this_week_progress": "Denne uges fremskridt",
    "this_month_progress": "Denne måneds fremskridt",
    "overall_progress": "Samlede fremskridt",
    "complete": "komplet",
    "overallSuccess": "Samlet succes",
    "teamSuccessAverage": "Gennemsnitlig succes for holdet",
    "progressDetails": "Detaljer om fremskridt",
    "dayStreak": "%{n}-dagsstribe!",
    "weekStreak": "%{n}-ugers stribe!",
    "dailyProgress": "Daglige fremskridt",
    "participantsSuccessCount": {
        "overall": "%{amount} af %{total} deltagere har nået målet",
        "day": "%{amount} af %{total} deltagere har nået målet i dag",
        "week": "%{amount} af %{total} deltagerne har nået målet i denne uge",
        "month": "%{amount} af %{total} deltagerne har nået målet i denne måned"
    },
    "doubleBonusShort": "Dobbelt bonus!",
    "doubleBonusLong": "Du har fortjent en dobbelt bonus!",
    "recommendedGoalDescription": "Mål hjælper dig med at holde styr på dine fremskridt og holde dig motiveret!",
    "noParticipation": "Ingen deltagelse",
    "nothingToShow": "Det ser ud til, at der ikke er noget at vise lige nu",
    "yourTeam": "Dit hold",
    "no_activity_title": "Ingen aktivitet",
    "brandSupport": {
        "description": "Vi har tilføjet understøttelse for aktivitetssynkronisering med Polar- og Withings-smartwatches. Tid til at komme i gang!"
    },
    "no_tracked_activities": "Du har ikke registreret nogen aktiviteter endnu.",
    "button_leave_community": "Forlad fællesskabet",
    "button_delete_challenge": "Slet %{challengeType}",
    "button_delete_community": "Slet fællesskab",
    "button_delete_activity": "Slet aktivitet",
    "library_header_description": "Originalt indhold til at uddanne, engagere og inspirere dig på din wellness-rejse.",
    "library_searchbar": "Søg i biblioteket...",
    "library_page_header": "Originalt indhold til at uddanne, engagere og inspirere dig på din wellness-rejse.",
    "onboarding_button_title": "Jeg er færdig",
    "refresh_bar": "Klik her for at opdatere",
    "content": {
        "min_read": "%{readingTime} min læst"
    },
    "noMembers": "Ingen medlemmer",
    "saved": "Gemte",
    "forYou": "Til dig",
    "min read (Note: min as in minutes)": "",
    "send me program related email notifications": "",
    "send me weekly email updates": "",
    "you can earn this bade once every quarter": "",
    "badgeInstruction": "%{badgeInstruction} inden",
    "youCanEarnThisBadge": "Du kan optjene dette badge én gang hver %{period}",
    "emailPreferences": "E-mailpræferencer",
    "unsubscribeText": "Fravælge alle e-mail-opdateringer",
    "savingText": "Gemmer...",
    "wrongTryLater": "Noget gik galt. Prøv venligst igen senere.",
    "preferencesSaved": "Præferencer gemt",
    "recommendedForYou": "Anbefalet til dig",
    "formerMember": {
        "label": "Tidligere medlem"
    },
    "selectionsFromLibrary": "Udvalg fra vores bibliotek udvalgt kun til dig",
    "goalsInfo": {
        "desc1": "for at fokusere på at forbedre dit velbefindende",
        "desc2": "Du har sat det maksimale antal mål."
    },
    "createMyOwn": "Opret min egen",
    "isAllSet": "er alle indstillet!",
    "undoLabel": "Fortryd",
    "terms": "Vilkår",
    "placeOrder": "Afgive ordre",
    "item": "Vare",
    "redeemFor": "Indløs for",
    "confirmYourOrder": "Bekræft din ordre",
    "orderComplete": "Bestilling gennemført",
    "redeemedFor": "Indløst for",
    "orderDetails": "Oplysninger om ordren",
    "bonusGoalReward": "Belønning for bonusmål",
    "orderSummary": "Ordreoversigt",
    "logoutSSO": {
        "title": "Du har meldt dig ud af %{programName}.",
        "description": "Vi ses snart igen!",
        "signinAgain": "Klik her for at logge ind igen"
    },
    "nothing_to_show": "Intet at vise lige nu",
    "no_saved_content": "Du har ikke noget gemt indhold",
    "restarts_every_week": "Genstarter hver uge",
    "myGoals": "Mine mål",
    "goalGallery": "Mål-galleri",
    "share_smth": "Lave et opslag...",
    "newFeatureModal": {
        "smartGoal": {
            "title": "Vores skridtmål er lige blevet smartere!",
            "description": "Dine uger er altid forskellige - det er dine mål nu også! \nMed Smart Mode justerer dit skridtmål sig selv på baggrund af din aktivitet i det virkelige liv. \nDet er indstillet med din succes og dit velvære for øje.",
            "action": "Tjek det ud!"
        },
        "mePage": {
            "title": "Den nye mig",
            "description": "Vi har omdesignet Me-sektionen for at gøre det lettere at finde de ting, du holder af - se her!",
            "letsSeeBtn": "Lad os se!",
            "llaterBtn": "Måske senere"
        },
        "bellEAP": {
            "title": "Velkommen til din online platform for dit Støtteprogram for medarbejdere og familier!",
            "description": "Udforsk de værktøjer og tjenester, der hjælper med at navigere velvære og livets udfordringer for dig og berettigede familiemedlemmer",
            "button": "Log ind nu eller besøg Hurtige links når som helst"
        },
        "quickActivityLogView": {
            "title": " En hurtigere måde at se din seneste aktivitet på",
            "description": "Du kan nu klikke på statuslinjen for at se din aktivitetslog."
        }
    },
    "goalSmartMode": {
        "title": "Smart Mode",
        "description": "Få personlige ugentlige mål baseret på dit seneste aktivitetsniveau.",
        "status": "Smart Mode er %{status} for dette mål.",
        "infoModal": {
            "descriptionOne": "Når Smart Mode er aktiveret, ændres målet for dette mål fra uge til uge baseret på dit seneste aktivitetsniveau.",
            "descriptionTwo": "Vi udfordrer dig lige præcis den rette mængde for at sætte dig i stand til at få succes.",
            "instructions": ""
        },
        "settings": {
            "switch": "Aktivering af Smart Mode for mit skridtmål",
            "description": "Når Smart Mode er slået til, får du et nyt skridtmål i begyndelsen af hver uge."
        },
        "enableSmartMode": "Aktiver Smart Mode",
        "settingsModal": {
            "descriptionTurnOn": "Dit mål for trinmålet ændres hver uge baseret på din aktivitet",
            "descriptionTurnOff": "Dit trinmålmål vil ikke længere blive personliggjort hver uge"
        }
    },
    "On": "På",
    "Off": "Off",
    "top_posts": "Top indlæg",
    "most_recent": "Seneste",
    "browseByTopic": "Gennemse efter emne",
    "video": "Video",
    "enable": "Aktiver",
    "turnOff": "Slå fra",
    "new_post": "Nyt indlæg",
    "new_post_in": "Nyt indlæg i",
    "dailyTarget": "Dagligt mål",
    "dailyTargetForWeek": "Dagligt mål for ugen",
    "showMyActivityLog": "Vis min aktivitetslogbog",
    "usersReacted": {
        "oneOther": "%{userName} og 1 anden",
        "multipleOthers": "%{userName} og %{count} andre"
    },
    "reactionsModal": {
        "title": "Flere måder at fejre på",
        "description": "Hils på dine kolleger med nye sociale post-reaktioner!"
    },
    "account": "Konto",
    "myWellbeingProfile": "Min velværeprofil",
    "physicalDetailsDescription": "Disse oplysninger er nødvendige for at beregne din trivselsscore",
    "wellbeingInterests": "Interesser for velvære",
    "myWellbeingInterests": "Mine trivselsinteresser",
    "preferredNameOptional": "Foretrukket navn (valgfrit)",
    "basicPhysicalDetails": "Grundlæggende fysiske oplysninger",
    "notRegistered": {
        "infoModal": {
            "title": "Vi kan ikke finde dig",
            "notInSystem": "er ikke i vores system.",
            "correctEmail": "Sørg for at bruge den korrekte konto (normalt en virksomheds mailadresse) og tjek for stavefejl.",
            "emailHelp": "Hvis du vil have mere hjælp, kan du sende en mail til vores supportteam på"
        }
    },
    "dontHaveAccount": "Har du ikke en konto?",
    "wasThisHelpful": "Var dette hjælpsomt?",
    "healthScoreFeedbackModal": {
        "emojiSection": "Hvor hjælpsom er denne side og din trivselsscore?",
        "commentSectionText": "Hvordan kunne de forbedres?",
        "commentSectionPlaceholder": "Tilføj en kommentar...",
        "thankYouModal": "Tak for din feedback!"
    },
    "number_connected": "%{numDevices} tilsluttet",
    "searchPlaceHolder": "Søg...",
    "noTeamsFound": "Ingen hold fundet",
    "join_a_challenge": "Deltag i en udfordring",
    "me_page_titles": {
        "goal": {
            "singular": "mål",
            "plural": "mål"
        },
        "challenge": {
            "singular": "udfordring",
            "plural": "udfordringer"
        }
    },
    "seeMoreText": "...se mere",
    "adjust_entry": "Opdater venligst det indtastede.",
    "overTracking": {
        "title": "Advarsel om oversporing",
        "desc1": {
            "singular": "Dette opslag vil blive revideret.",
            "plural": "Disse opslag vil blive revideret."
        },
        "desc2": "Oversporing kan medføre suspension af kontoen.",
        "button_edit": "Rediger mine opslag",
        "button_confirm": "Indsend som den er"
    },
    "oneEventAttendee": "1 deltager",
    "multipleEventAttendees": "%{num} deltagere",
    "to": "til",
    "eventBonusFull": "Du optjener %{number} bonus %{points} for at deltage i denne begivenhed.",
    "eventBonusBold": "%{number} bonus %{points}",
    "didYouLikeArticle": "Kunne du lide denne artikel?",
    "didYouLikeVideo": "Kunne du lide denne video?",
    "tellUsMore": "Fortæl os mere...",
    "thanksForFeedback": "Tak for din feedback!",
    "challengesSubtitle": "Nå et mål sammen med andre deltagere—eller spil for at vinde!",
    "appStoreNameSprout": "Sprout at Work",
    "appStoreNameLiveBetter": "Medibank Live Better",
    "appStoreNameTelus": "TELUS Health Velvære",
    "huaweiStoreUrlSprout": "https:\/\/appgallery.huawei.com\/app\/C104993765",
    "telusHealthVirtualCare": "TELUS Health Virtuel pleje",
    "virtualCare": "Virtuel pleje",
    "changePassword": {
        "telus": {
            "info": "Din adgangskode administreres gennem din %{telusVC} konto.",
            "button": "Skift din %{virtualCare} adgangskode"
        }
    },
    "actions": "handlinger",
    "onAndUpcoming": "Igangværende & kommende",
    "termsAndPrivacyPolicyNew": "Ved at fortsætte, accepterer du",
    "invitedToTeam": "Inviteret til %{firstName} %{lastName}'s hold",
    "decline": "Afvis",
    "invitedToChallenge": "Inviteret af %{firstName} %{lastName}",
    "goalsCard": {
        "emptyStateTitle": "Du har ikke sat nogen mål"
    },
    "huaweiStoreUrlTelus": "https:\/\/appgallery.huawei.com\/app\/C107357173",
    "challengesCard": {
        "emptyStateTitle": "Du er ikke tilmeldt nogen udfordringer",
        "buttonLabel": "Find udfordringer"
    },
    "menu": "Menu",
    "everyone": "Alle sammen",
    "confirmEmployeeID": "Bekræft medarbejder-id",
    "employeeIDNoMatch": "Disse id matcher ikke endnu",
    "hidePost": "Skjul opslag fra %{ownerName}",
    "hidingUserPostToast": {
        "success": {
            "title": "Skjult bruger",
            "message": "Du vil ikke se opslag fra denne bruger længere."
        }
    },
    "moderateHideUserDescription": "Ved at skjule opslag fra denne bruger, fjernes specifikt indhold fra din stream.",
    "startsInOneDay": "Starter om 1 dag",
    "endsInOneDay": "Slutter om 1 dag",
    "endsToday": "Slutter i dag",
    "hrisEmployeeID": {
        "infoModal": {
            "notInSystem": "ikke i vores system. Har du indtastet det korrekt?",
            "administrator": "Hvis du er nyansat, kan det ske at vi ikke har dit medarbejder-id endnu. Spørg venligst din administrator hvornår du kan prøve igen.",
            "emailNotInSystem": "Hvis du er nyansat, kan det være at din mailadresse endnu ikke er oprettet i vores system. Spørg venligst din administrator hvornår du kan prøve igen.",
            "eligibleEmail": "er ikke en gyldig mailadresse. Er den indtastet korrekt?"
        }
    },
    "oneMember": "1 medlem",
    "programCode": {
        "infoModal": {
            "unique": "Din virksomhed har en unik programkode som du normalt modtager i en mail.",
            "support": "Hvis du ikke kan finde din kode, kan du kontakte administratoren for dit velværeprogram eller kontakte support@sproutatwork.com med navnet på din virksomhed."
        },
        "instructions": "Indtast programkoden fra din arbejdsgiver for at komme i gang"
    },
    "whatsMyProgramCode": "Hvad er min programkode?",
    "enjoyApp": "Brug vores app på mobil",
    "programCodeLabel": "Programkode",
    "createdByMembersChallenges": "Oprettet af medlemmer",
    "invites": "Invitationer",
    "recommendedContentTitle": "Udvalgt indhold til dig",
    "amountExchanged": "Udvekslet beløb",
    "orderStatus": "Ordrestatus",
    "orderSuccessfulyyItemForConfirmation": "Ordre godkendt! En bekræftelsesmail er blevet sendt til %{email}.",
    "orderedOnDateText": "Bestilt %{orderCreatedTime}",
    "personalize": {
        "communities": {
            "title": "Find dine fællesskaber",
            "description": "Fællesskaber bringer folk med delte interesser sammen. Du kan melde dig til eller forlade et fællesskab når som helst."
        },
        "objectives": {
            "title": "Mine mål",
            "description": "Hvad kan vi hjælpe dig med at sætte i gang eller vedligeholde? Vi bruger dit svar til at forbedre vores anbefalinger."
        },
        "topics": {
            "title": "Mine trivselsemner",
            "description": "Du kan se flere tips og vejledninger ud fra disse valg."
        }
    },
    "recommendedCardDesc": "Sæt op til 3 mål, der sætter fokus på bedre velvære",
    "accessibility": {
        "track_activity": "Spor aktivitet",
        "cardbody": "Kort krop",
        "cardcontainer": "Kort beholder",
        "cardfooter": "Kort sidefod",
        "unstartedChallengeHeader": "Ustartet udfordring",
        "activeOrEndedChallengeWrapper": "Udfordring wrapper",
        "activeOrEndedChallengeHeader": "Udfordring sidehoved",
        "goalHeader": "Mål sidehoved",
        "openOptions": "Åbn Indstillinger"
    },
    "teams": {
        "teamInvites": "Holdinvitationer",
        "findTeam": "Find et hold",
        "teamFull": "Holdet er fyldt"
    },
    "deleteAccountText": "Slet din Sprout at Work-konto og alle dens data permanent",
    "deleteAccountButtonTitle": "Slet min konto",
    "joinTeamActionSheetText": "Tilmeld dig eller opret et hold for at deltage i denne udfordring",
    "frequencyNone": "ingen",
    "quickLinkTitle": "Hurtige links",
    "moreTab": "Mere",
    "addedBy": "Tilføjet af %{companyName}",
    "teamsTitle": "Hold",
    "helpAndSupport": "Hjælp & support til app",
    "feedbackTitle": "Giv feedback",
    "feedbackDescription": "Fortæl os hvad du godt kan lide ved appen og hvad vi kan forbedre.",
    "leaveTeamAction": "Forlad holdet",
    "teamActions": "Hold handlinger",
    "leaveTeamLeaveChallenge": "Hvis du forlader dette hold, afslutter din deltagelse i udfordringen. Du skal være medlem af et hold for at fortsætte med at deltage.",
    "familyMembers": "Familiemedlemmer",
    "familyMembersDescription": "Familiemedlemmer skal være mindst 16. De får fuld adgang til og overblik over hele platformen.",
    "learnMoreButton": "Lær mere",
    "thvcSelection": {
        "signUpUsingTelus": "Opret en bruger med din TELUS Health Virtuel pleje-konto",
        "loginGetStarted": "Log ind på Virtuel pleje for at komme i gang",
        "haveAccount": "Har du en Virtuel pleje-konto?",
        "emailHelp": "Brug for hjælp? Kontakt support på",
        "yes": "Ja",
        "signMeUp": "Nej, meld mig til"
    },
    "inviteFamilyMember": {
        "label": "Inviter familiemedlem",
        "btn": "Send invitation",
        "email": "Mailadresse*",
        "firstName": "Fornavn*",
        "lastName": "Efternavn*",
        "approval": "Jeg bekræfter at jeg har tilladelse til at invitere dette familiemedlem til %{company}",
        "multiSelect1": "Er dette familiemedlem myndig i din region?",
        "multiSelect2": "Er dette familiemedlem mindst 16 år?",
        "confirmTermsPolicy": "Jeg bekræfter at jeg er denne persons værge. I min mening, er vedkommende tilstrækkeligt moden til at acceptere at bruge platformen, og jeg giver dem tilladelse til at tilmelde sig. Jeg pådrager mig ansvaret for at forklare behovet for ansvarlig adfærd på platformen og hvordan platformen indsamler og bruger deres data.",
        "onTheirBehalf": "på deres vegne.",
        "confirm": "Ja, jeg bekræfter ovenstående",
        "warning": "Familiemedlemmet skal være mindst 16 for at tilmelde sig",
        "errorMsg": "Gennemgå venligst fejl inden du fortsætter"
    },
    "deleteFamilyMember": {
        "desc": "Sletning af et familiemedlems konto er permanent.",
        "btn": "Slet familiemedlem",
        "confirmation": {
            "title": "Familiemedlem slettet",
            "desc": "%{fullName}'s konto blev slettet"
        },
        "areYouSure": "Er du sikker på at du vil slette %{fullName}'s konto?"
    },
    "familyInvitationStatus": {
        "active": "Aktiv",
        "sent": "Invitation sendt"
    },
    "familyInvitationSent": {
        "title": "Invitationsmail sendt",
        "desc": "Invitation sendt til %{fullName}"
    },
    "programCodeSignup": "Brug venligst %{programCodeLabel} %{programCode} når du har klikket på \"%{signUpLabel}\"",
    "notJoinedCommunityLabel": "Meld dig til dette fællesskab for at se hvad andre medlemmer deler",
    "moda": {
        "installApp": {
            "title": "Bemærk venligst: Moda Health-medlemmer kan kun få adgang til Sprout at Work gennem deres medlemskontrolpanel.",
            "subtitle": "For at bruge Sprout at Work på din smartphone:",
            "stepOneA": "1. Installer Sprout at Work-appen på mobil.",
            "stepOneB": "Du må ikke tilmelde dig eller logge ind på mobilappen.",
            "stepTwo": "2. Log ind på dit Member Dashboard på din mobiltelefon",
            "stepThree": "3. Gå til Sprout wellness-programmet og følg det link - det skulle åbne Sprout at Work-mobilappen."
        }
    },
    "HRISLocationSelection": {
        "title": "Hvilket land arbejder du fra?"
    },
    "visibilitySettings": {
        "title": "Indstillinger for synlighed",
        "desc1": "Er det okay at være synlig for andre Wellbeing-appmedlemmer i din virksomhed?",
        "desc2": "Du kan altid ændre dette senere.",
        "moreTextQ1": "Hvad kan andre mennesker se?",
        "moreTextAnswer1": "Dit navn, profilbillede og grundlæggende profiloplysninger (som afdeling og placering) kan ses af personer i din virksomhed. Dette gør appen mere social og sjov.",
        "moreTextQ2": "Hvor vises jeg?",
        "moreTextAnswer2": "Du vil blive vist som deltager i udfordringer, fællesskaber og begivenheder, du deltager i, på ranglister og i søgeresultater. Du kan justere dette senere.",
        "moreTextAnswer3": "Vi deler eller viser ikke dine personlige helbredsoplysninger, såsom din højde, vægt eller den aktivitet, du sporer.",
        "btnAgree": "Det er okay at vise mig",
        "btnDisagree": "Lad ikke andre medlemmer se mig"
    },
    "privacyPolicyReadMore": "For at lære mere, læs vores privatlivspolitik",
    "tellMeMore": "Fortæl mig mere",
    "helpUsImprove": {
        "title": "Hjælp os med at blive bedre",
        "desc1": "Vi bruger værktøjer, der registrerer anonyme brugsdata. At se tendenser i, hvad folk ser og klikker på, hjælper os med at gøre appen bedre.",
        "desc2": "Du kan til enhver tid slå dette fra.",
        "moreTextQ1": "Hvad vi ser på",
        "moreTextAnswer1": "Vi er interesserede i overordnede tendenser og statistikker, så vi ser ikke på data på individniveau.",
        "moreTextQ2": "Vi deler ikke dine data",
        "moreTextAnswer2": "Disse data er kun tilgængelige for de personer, der bygger denne app for at hjælpe med at gøre den bedre. Vi deler det ikke med andre virksomheder, inklusive din arbejdsgiver.",
        "moreTextQ3": "Dine data er anonyme",
        "moreTextAnswer3": "Vores værktøjer registrerer ikke dit navn, nøjagtige placering eller nogen personlige helbredsoplysninger.",
        "btnAgree": "Spor min brug anonymt",
        "btnDisagree": "Jeg giver ikke samtykke til sporing"
    },
    "deleteAccountTextAppName": "Slet din %{appName}-konto og alle dens data permanent",
    "anonymousMember": "Anonymt medlem",
    "activitiesToTrack": {
        "title": "Aktiviteter at spore"
    },
    "includedInMembership": "Inkluderet i dit medlemskab",
    "invalidDate": "Ugyldig dato",
    "discardsStreamPost": {
        "discardTitle": "Vil du kassere indlægget?",
        "discardChangesTitle": "Vil du kassere ændringer?",
        "discardPostText": "Er du sikker på, at du vil kassere dit indlæg?",
        "discardPostChangesText": "Er du sikker på, at du vil kassere dine ændringer?"
    },
    "trackActivityModalTitle": "Spor for %{date}",
    "noPosts": "Ingen indlæg at se",
    "goalIcon": "Målikon",
    "resetsOn": "Nulstiller den %{date}",
    "clickForHelp": "Klik her for at få hjælp",
    "trackActivityInputLabel": "Indtast %{unit} %{activityName} %{dateFormat}",
    "itemsFound": "Varer fundet",
    "tagState": {
        "active": "Aktiv",
        "notActive": "Ikke aktiv"
    },
    "bonusCheckmarkLabel": "Modtog %{bonusLabel} bonuspoint til færdiggørelse",
    "searchBar": {
        "searching": "søger %{term}",
        "result": "søgeresultater"
    },
    "activityProgress": "Aktivitetsfremskridt - %{levelName} %{percentFilled}% - Nulstilles om %{daysLeft} dage",
    "bookmark": {
        "remove": "Fjern fra gemte elementer",
        "save": "Gem denne vare"
    },
    "bonusMark": {
        "earn": "Tjen %{qty} %{point}",
        "earned": "Du har optjent %{qty} %{point}"
    },
    "tabToTrackActivity": "Tryk for at spore aktivitet",
    "videoElementLabel": "%{title}, varighed %{duration}, Tryk to gange for at afspille video",
    "updatedPoliciesPopup": {
        "title": "Vi har opdateret vores vilkår",
        "details": "Vi opfordrer dig til at læse vores opdaterede politikker nedenfor:",
        "disclaimer": "Ved at klikke på knappen nedenfor accepterer og anerkender du de opdaterede politikker.",
        "agree": "Jeg er enig"
    },
    "editActivityLog": {
        "canNotEditItem": "Du kan ikke redigere denne post",
        "canNotEditItemDescription": "Redigering er ikke tilgængelig for aktiviteter, der er synkroniseret fra enheder eller apps.",
        "updatedItem": "Aktiviteten er opdateret",
        "updatedItemDescription": "Dine ændringer er blevet gemt."
    },
    "login_with_email": "Log ind med e-mail",
    "healthconnect_not_available": "Kan ikke oprette forbindelse til Health Connect. I Health Connect-appen skal du sørge for, at tilladelser er aktiveret.",
    "registrationField": {
        "required": {
            "firstName": "Indtast venligst dit fornavn",
            "lastName": "Indtast venligst dit efternavn",
            "email": "Indtast venligst en gyldig e-mailadresse",
            "password": "Indtast venligst en gyldig adgangskode"
        }
    },
    "settingsErrorMessage": {
        "firstName": "Indtast venligst dit fornavn",
        "lastName": "Indtast venligst dit efternavn"
    },
    "requiredValidValue": "Indtast venligst en gyldig værdi for din %{value}",
    "passwordHidden": "Adgangskode skjult, tryk for at vise adgangskode",
    "passwordShown": "Adgangskoden vises, tryk for at skjule adgangskoden",
    "libraryHeaderContent": {
        "category": "",
        "points": "Optjen %{points} point."
    },
    "scoreCurrentPeriod": "%{text} er fra %{startDate} til %{endDate}",
    "scoreCurrent": "%{text} er %{points} point",
    "abbotResetPasswordModal": {
        "title": "Forsøger du at få adgang til en konto fra sidste år?",
        "text": " Hvis du tilmeldte dig sidste års udfordring, fungerer den konto ikke længere. Du skal tilmelde dig i år.",
        "goToResetPasswordBtn": "Jeg tilmeldte mig i %{currentYear}",
        "goToSignupBtn": "Jeg har ikke tilmeldt mig i %{currentYear}"
    },
    "challengeRegistrationClosed": "Tilmelding lukket - Udfordring er startet"
};